import React, { ReactElement } from 'react';
import styled from 'styled-components';
import {
  AccessibilityIcon,
  ActivityIcon,
  AirplayIcon,
  AlertCircleIcon,
  AlertOctagonIcon,
  AlertTriangleIcon,
  AlignCenterIcon,
  AlignJustifyIcon,
  AlignLeftIcon,
  AlignRightIcon,
  AnchorIcon,
  ApertureIcon,
  ArchiveIcon,
  ArrowDownCircleIcon,
  ArrowDownLeftIcon,
  ArrowDownRightIcon,
  ArrowDownUpIcon,
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  ArrowUpCircleIcon,
  ArrowUpLeftIcon,
  ArrowUpRightIcon,
  AwardIcon,
  BabyIcon,
  BadgePercentIcon,
  BarChart2Icon,
  BarChartIcon,
  BatteryChargingIcon,
  BatteryIcon,
  BedDoubleIcon,
  BellIcon,
  BellOffIcon,
  BluetoothIcon,
  BoldIcon,
  BookIcon,
  BookmarkIcon,
  BriefcaseIcon,
  CameraIcon,
  CameraOffIcon,
  CastIcon,
  CheckSquareIcon,
  ChevronsDownIcon,
  ChevronsLeftIcon,
  ChevronsRightIcon,
  ChevronsUpIcon,
  ChromeIcon,
  CircleIcon,
  ClipboardIcon,
  CloudDrizzleIcon,
  CloudIcon,
  CloudLightningIcon,
  CloudOffIcon,
  CloudRainIcon,
  CloudSnowIcon,
  CodeIcon,
  CodepenIcon,
  CodesandboxIcon,
  CoffeeIcon,
  ColumnsIcon,
  CommandIcon,
  CompassIcon,
  CornerDownLeftIcon,
  CornerDownRightIcon,
  CornerLeftDownIcon,
  CornerLeftUpIcon,
  CornerRightDownIcon,
  CornerRightUpIcon,
  CornerUpLeftIcon,
  CornerUpRightIcon,
  CpuIcon,
  CreditCardIcon,
  CropIcon,
  CrosshairIcon,
  DatabaseIcon,
  DeleteIcon,
  DiscIcon,
  DollarSignIcon,
  DownloadCloudIcon,
  DropletIcon,
  Edit2Icon,
  Edit3Icon,
  ExpandIcon,
  ExternalLinkIcon,
  EyeIcon,
  EyeOffIcon,
  FastForwardIcon,
  FeatherIcon,
  FigmaIcon,
  FileIcon,
  FileMinusIcon,
  FilePlusIcon,
  FileTextIcon,
  FilmIcon,
  FlagIcon,
  FolderIcon,
  FolderMinusIcon,
  FolderPlusIcon,
  FramerIcon,
  FrownIcon,
  GiftIcon,
  GitBranchIcon,
  GitCommitIcon,
  GithubIcon,
  GitlabIcon,
  GitMergeIcon,
  GitPullRequestIcon,
  GlobeIcon,
  GridIcon,
  GripHorizontalIcon,
  HardDriveIcon,
  HashIcon,
  HeadphonesIcon,
  HexagonIcon,
  ImageIcon,
  InboxIcon,
  ItalicIcon,
  LayersIcon,
  LayoutIcon,
  LeafIcon,
  LifeBuoyIcon,
  Link2Icon,
  LinkedinIcon,
  LinkIcon,
  ListCheckIcon,
  ListFilterIcon,
  ListIcon,
  LoaderIcon,
  LogOutIcon,
  LucideProps,
  MapIcon,
  MapPinIcon,
  Maximize2Icon,
  MaximizeIcon,
  MehIcon,
  MessageCircleIcon,
  MessageSquareIcon,
  MicIcon,
  MicOffIcon,
  Minimize2Icon,
  MinusSquareIcon,
  MonitorIcon,
  MoonIcon,
  MoreHorizontalIcon,
  MoreVerticalIcon,
  MousePointerIcon,
  MoveIcon,
  MusicIcon,
  Navigation2Icon,
  NavigationIcon,
  NewspaperIcon,
  OctagonIcon,
  PaintbrushIcon,
  PaperclipIcon,
  PauseCircleIcon,
  PencilIcon,
  PenToolIcon,
  PercentIcon,
  PhoneCallIcon,
  PhoneForwardedIcon,
  PhoneIncomingIcon,
  PhoneMissedIcon,
  PhoneOffIcon,
  PhoneOutgoingIcon,
  PieChartIcon,
  PlayCircleIcon,
  PlusCircleIcon,
  PlusSquareIcon,
  PocketIcon,
  PowerIcon,
  PrinterIcon,
  RadioIcon,
  ReceiptTextIcon,
  RefreshCcwIcon,
  RefreshCwIcon,
  RewindIcon,
  RotateCcwIcon,
  RotateCwIcon,
  RssIcon,
  RulerIcon,
  ScanSearchIcon,
  ScissorsIcon,
  ScissorsLineDashedIcon,
  SendIcon,
  ServerIcon,
  Share2Icon,
  ShieldCheckIcon,
  ShieldIcon,
  ShieldOffIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  ShuffleIcon,
  SidebarIcon,
  SkipBackIcon,
  SkipForwardIcon,
  SlackIcon,
  SlashIcon,
  SlidersHorizontalIcon,
  SmartphoneIcon,
  SmileIcon,
  SpeakerIcon,
  SquareIcon,
  StarIcon,
  StopCircleIcon,
  SunIcon,
  SunriseIcon,
  SunsetIcon,
  SwatchBookIcon,
  TabletIcon,
  TagIcon,
  TerminalIcon,
  ThermometerIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  ToggleLeftIcon,
  ToggleRightIcon,
  Trash2Icon,
  TrashIcon,
  TrelloIcon,
  TrendingDownIcon,
  TrendingUpIcon,
  TriangleIcon,
  TvIcon,
  TwitchIcon,
  TwitterIcon,
  TypeIcon,
  UmbrellaIcon,
  UnderlineIcon,
  UnlockIcon,
  UploadCloudIcon,
  UploadIcon,
  UserCheckIcon,
  UserMinusIcon,
  UserPlusIcon,
  UsersIcon,
  UserXIcon,
  VideoIcon,
  VideoOffIcon,
  VoicemailIcon,
  Volume1Icon,
  Volume2Icon,
  VolumeIcon,
  VolumeXIcon,
  WatchIcon,
  WifiIcon,
  WifiOffIcon,
  WindIcon,
  XCircleIcon,
  XIcon,
  XOctagonIcon,
  XSquareIcon,
  YoutubeIcon,
  ZapIcon,
  ZapOffIcon,
} from 'lucide-react';
import { theme } from '../layout/theme';
import { size } from '../layout/helpers';
import { IconSize } from '@components/Icon';

export interface IStyledIcon {
  className?: string;
  strokeWidth?: string;
}

export const BackPlate = styled.div`
  border-radius: 50%;
  background: ${theme.colors.bg.highlight};
  color: ${theme.colors.ui.info};
  padding: ${size(1)};

  &.positive {
    background: ${theme.colors.bg.info};
    color: ${theme.colors.ui.positive};
  }

  &.warning {
    background: ${theme.colors.bg.member};
    color: ${theme.colors.text.main};
  }

  &.neutral {
    background: ${theme.colors.bg.accent};
    color: ${theme.colors.text.alt};
  }

  &.border {
    border: 1px solid ${theme.colors.bg.infoActive};
  }

  &.alt {
    background: ${theme.colors.bg.alt};
    color: ${theme.colors.text.onColor};
  }
`;

const BaseSvg = styled.svg`
  display: block;
  width: 1em;
  height: 1em;
  overflow: visible;
  fill: none;
  font-size: 16px;

  &.inline {
    display: inline;
  }
  &.xsmall {
    font-size: 12px;
  }
  &.small {
    font-size: 14px;
  }
  &.large {
    font-size: 20px;
  }
  &.xlarge {
    font-size: 24px;
  }
  &.xxlarge {
    font-size: 32px;
  }
  &.xxxlarge {
    font-size: 40px;
  }
  &.bump-down {
    margin-top: 2px;
  }
  &.adjust-top {
    margin-top: 2px;
  }

  // Mio 2025
  &.xs {
    font-size: var(--mio-size-space-300)
  }
  &.sm {
    font-size: var(--mio-size-space-400)
  }
  &.md {
    font-size: var(--mio-size-space-600)
  }
  &.lg {
    font-size: var(--mio-size-space-800)
  }
  &.xl {
    font-size: var(--mio-size-space-1000)
  }
  &.xxl {
    font-size: var(--mio-size-space-1200)
  }
  &.xxxl {
    font-size: var(--mio-size-space-1400)
  }
`;

const FillSvg = styled(BaseSvg)`
  fill: currentColor;
  stroke: none;

  &#banIcon {
    width: 14px;
    height: 14px;
  }
`;

const StrokeSvg = styled(BaseSvg)`
  stroke: currentColor;
`;

export const PlayIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 56 56" className={className}>
    <g clipPath="url(#clip0_75_16)">
      <path d="M45.5683 29.1547L15.7224 48.7667C15.0753 49.192 14.2011 49.0196 13.7698 48.382C13.6156 48.1539 13.5333 47.886 13.5333 47.612V8.38783C13.5333 7.62133 14.1637 7 14.9413 7C15.2193 7 15.4911 7.08111 15.7224 7.23307L45.5683 26.8451C46.2152 27.2703 46.3901 28.1322 45.9587 28.7697C45.8556 28.9221 45.7229 29.0531 45.5683 29.1547Z" />
    </g>
    <defs>
      <clipPath id="clip0_75_16">
        <rect width="56" height="56" fill="white" />
      </clipPath>
    </defs>
  </FillSvg>
);

export const BookOpenIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M30.2 1.8h-8.5c-2.3 0-4.3 1-5.7 2.6-1.4-1.6-3.4-2.6-5.7-2.6H1.8c-1 0-1.8.8-1.8 1.8v20.7c0 1 .8 1.8 1.8 1.8h10c1.4 0 2.5 1.1 2.5 2.4 0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8c0-1.3 1.1-2.4 2.5-2.4h10c1 0 1.8-.8 1.8-1.8V3.6c-.2-1-1-1.8-2-1.8zM14.2 23c-.8-.3-1.6-.5-2.5-.5H3.6V5.3h6.8c2.2 0 3.9 1.7 3.9 3.8V23zm14.2-.5h-8.2c-.9 0-1.7.2-2.5.5V9c0-2.1 1.8-3.8 3.9-3.8h6.8v17.3z" />
  </FillSvg>
);

export const ChevronDownIcon = ({ className, strokeWidth }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth={strokeWidth || 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ChevronLeftIcon = ({ className, strokeWidth }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M15 18l-6-6 6-6"
      stroke="currentColor"
      strokeWidth={strokeWidth || 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ChevronRightIcon = ({ className, strokeWidth }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M9 18l6-6-6-6"
      stroke="currentColor"
      strokeWidth={strokeWidth || 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ChevronUpIcon = ({ className, strokeWidth }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M18 15l-6-6-6 6"
      stroke="currentColor"
      strokeWidth={strokeWidth || 1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const AppIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16 1.5l-14.5 4.1v19.7l14.5 5.2 14.5-5.2v-19.7l-14.5-4.1zM28.2 6.5l-12.2 4.1-12.2-4.1 12.2-3.4 12.2 3.4zM3 7.9l12.2 4.1v16.7l-12.2-4.4v-16.4zM16.8 28.6v-16.6l12.2-4.1v16.4l-12.2 4.3z" />
  </FillSvg>
);

export const ArrowDownIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M15.3 27.8c0.1 0 0.1 0 0 0 0.1 0.1 0.2 0.1 0.2 0.1s0 0 0.1 0c0 0 0.1 0 0.1 0 0.1 0 0.2 0 0.2 0 0.1 0 0.2 0 0.2 0 0.1 0 0.1 0 0.1 0s0 0 0.1 0 0.1-0.1 0.2-0.1c0 0 0 0 0.1 0s0.1-0.1 0.2-0.1c0 0 0 0 0 0l10.2-10.2c0.5-0.5 0.5-1.2 0-1.7s-1.2-0.5-1.7 0l-8.1 8.1v-18.7c0-0.6-0.5-1.2-1.2-1.2s-1.2 0.5-1.2 1.2v18.6l-8.1-8.1c-0.5-0.5-1.2-0.5-1.7 0-0.2 0.2-0.4 0.5-0.4 0.8s0.1 0.6 0.4 0.8l10.1 10.1c0 0 0 0 0 0 0.1 0.3 0.2 0.3 0.2 0.4v0z" />
  </FillSvg>
);

export const ArrowLeftIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M19 12H5M12 19l-7-7 7-7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ArrowRightIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.723 16.696c0.012-0.017 0.019-0.037 0.030-0.055 0.029-0.049 0.058-0.097 0.080-0.15 0.010-0.024 0.015-0.049 0.023-0.074 0.017-0.049 0.035-0.097 0.045-0.149 0.016-0.077 0.024-0.156 0.024-0.236s-0.008-0.159-0.024-0.236c-0.011-0.052-0.029-0.101-0.046-0.15-0.008-0.024-0.013-0.049-0.023-0.073-0.023-0.054-0.052-0.103-0.082-0.152-0.010-0.017-0.017-0.036-0.029-0.053-0.043-0.064-0.092-0.124-0.146-0.178-0.001-0.001-0.001-0.001-0.001-0.002l-10.12-10.12c-0.466-0.466-1.222-0.466-1.688 0s-0.466 1.222 0 1.689l8.082 8.082h-18.642c-0.659 0-1.194 0.534-1.194 1.194s0.534 1.194 1.194 1.194h18.642l-8.082 8.082c-0.466 0.466-0.466 1.222 0 1.688 0.233 0.233 0.539 0.35 0.844 0.35s0.611-0.117 0.844-0.35l10.12-10.12c0.004-0.004 0.007-0.010 0.011-0.014 0.050-0.051 0.096-0.106 0.136-0.166z" />
  </FillSvg>
);

export const ArrowUpIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16.7 4.2c-0.1 0-0.1 0 0 0-0.1-0.1-0.2-0.1-0.2-0.1s0 0-0.1 0c0 0-0.1 0-0.1 0-0.1 0-0.2 0-0.2 0-0.1 0-0.2 0-0.2 0-0.1 0-0.1 0-0.1 0s0 0-0.1 0-0.1 0.1-0.2 0.1c0 0 0 0-0.1 0s-0.1 0.1-0.2 0.1c0 0 0 0 0 0l-10.2 10.2c-0.5 0.5-0.5 1.2 0 1.7s1.2 0.5 1.7 0l8.1-8.1v18.6c0 0.7 0.5 1.2 1.2 1.2s1.2-0.5 1.2-1.2v-18.6l8.1 8.1c0.5 0.5 1.2 0.5 1.7 0 0.2-0.2 0.4-0.5 0.4-0.8s-0.1-0.6-0.4-0.8l-10.2-10.2c0 0 0 0 0 0 0-0.1-0.1-0.1-0.1-0.2v0z" />
  </FillSvg>
);

export const BanIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" id="banIcon" className={className}>
    <path d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2C6.47,2 2,6.47 2,12C2,17.53 6.47,22 12,22C17.53,22 22,17.53 22,12C22,6.47 17.53,2 12,2M14.59,8L12,10.59L9.41,8L8,9.41L10.59,12L8,14.59L9.41,16L12,13.41L14.59,16L16,14.59L13.41,12L16,9.41L14.59,8Z" />
  </FillSvg>
);

export const BarsIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.882 7.651h-23.775c-0.714 0-1.293-0.579-1.293-1.293s0.579-1.293 1.293-1.293h23.775c0.714 0 1.293 0.579 1.293 1.293s-0.579 1.293-1.293 1.293zM27.882 17.345h-23.775c-0.714 0-1.293-0.579-1.293-1.293s0.579-1.293 1.293-1.293h23.775c0.714 0 1.293 0.579 1.293 1.293s-0.579 1.293-1.293 1.293zM27.882 27.039h-23.775c-0.714 0-1.293-0.579-1.293-1.293s0.579-1.293 1.293-1.293h23.775c0.714 0 1.293 0.579 1.293 1.293s-0.579 1.293-1.293 1.293z" />
  </FillSvg>
);

export const BarsAltIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M2.7 9h26.6v1.7h-26.6v-1.7z" />
    <path d="M2.7 15.6h26.6v1.7h-26.6v-1.7z" />
    <path d="M2.7 22.3h14.9v1.7h-14.9v-1.7z" />
  </FillSvg>
);

export const BoxIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M30.537 3.373c-0.003-0.019-0.008-0.038-0.013-0.057-0.011-0.046-0.025-0.091-0.042-0.134-0.006-0.016-0.012-0.033-0.019-0.049-0.025-0.056-0.053-0.11-0.087-0.161-0.007-0.010-0.015-0.019-0.022-0.029-0.029-0.041-0.061-0.080-0.096-0.116-0.013-0.013-0.026-0.026-0.039-0.039-0.035-0.033-0.072-0.063-0.111-0.092-0.012-0.009-0.024-0.019-0.036-0.027-0.048-0.032-0.099-0.061-0.153-0.085-0.003-0.001-0.007-0.002-0.010-0.004-0.014-0.006-0.028-0.010-0.042-0.015-0.046-0.018-0.093-0.032-0.141-0.044-0.019-0.004-0.038-0.008-0.058-0.012-0.055-0.010-0.111-0.016-0.166-0.017-0.007 0-0.014-0.002-0.021-0.002h-0.016c0 0 0 0-0.001 0h-19.462c-0.24 0-0.474 0.081-0.663 0.229l-7.343 5.759c-0.341 0.267-0.474 0.699-0.38 1.095v19.005c0 0.692 0.561 1.253 1.253 1.253h19.914c0.093 0.026 0.188 0.043 0.283 0.043 0.29 0 0.579-0.116 0.79-0.346l6.415-6.964c0.183-0.198 0.284-0.458 0.284-0.728v-18.27c0.002-0.066-0.006-0.13-0.018-0.193zM22.782 8.153h-7.772l4.010-3.513h7.664l-3.902 3.513zM10.373 4.64h7.017l-4.010 3.513h-7.488l4.481-3.513zM21.742 27.324h-17.619v-16.664h17.62v16.664zM28.408 21.416l-4.16 4.516v-16.208l4.16-3.745v15.437z" />
  </FillSvg>
);

export const BoxInsideHouseIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 50 32" className={className}>
    <path d="M14 32H6a1 1 0 0 1-1-1V17.92a1 1 0 0 1 2 0V30h6v-6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v6a1 1 0 0 1-1 1z" />
    <path d="M1 18.63a1 1 0 0 1-.67-.25A1 1 0 0 1 .26 17L15.2.33a1 1 0 0 1 1.48 0l10.06 11.2a1 1 0 0 1-1.48 1.34L15.94 2.5 1.74 18.3a1 1 0 0 1-.74.33zM31 32H20a1 1 0 0 1-1-1V20a1 1 0 0 1 .29-.71l4-4A1 1 0 0 1 24 15h11a1 1 0 0 1 1 1v11a1 1 0 0 1-.29.71l-4 4A1 1 0 0 1 31 32zm-10-2h9.59L34 26.59V17h-9.59L21 20.41z" />
    <path d="M31 32a1 1 0 0 1-1-1V21H20a1 1 0 0 1 0-2h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z" />
    <path d="M31 21a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l4-4a1 1 0 0 1 1.42 1.42l-4 4A1 1 0 0 1 31 21z" />
  </FillSvg>
);

export const BoxOutsideHouseIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 50 32" className={className}>
    <path d="M26 32h-7a1 1 0 0 1-1-1v-6h-3v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V17.92a1 1 0 0 1 2 0V30h6v-6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6h5V18a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1z" />
    <path d="M30.88 18.63a1 1 0 0 1-.74-.33L15.94 2.5 1.74 18.3a1 1 0 0 1-1.41.08A1 1 0 0 1 .26 17L15.2.33a1 1 0 0 1 1.48 0L31.62 17a1 1 0 0 1-.07 1.42 1 1 0 0 1-.67.21zM45 32H34a1 1 0 0 1-1-1V20a1 1 0 0 1 .29-.71l4-4A1 1 0 0 1 38 15h11a1 1 0 0 1 1 1v11a1 1 0 0 1-.29.71l-4 4A1 1 0 0 1 45 32zm-10-2h9.59L48 26.59V17h-9.59L35 20.41z" />
    <path d="M45 32a1 1 0 0 1-1-1V21H34a1 1 0 0 1 0-2h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1z" />
    <path d="M45 21a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l4-4a1 1 0 0 1 1.42 1.42l-4 4A1 1 0 0 1 45 21z" />
  </FillSvg>
);

export const CalendarIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M26.5 7h-3V4h-3v3h-3V4h-3v3h-3V4h-3v3h-3C4.7 7 4 7.7 4 8.5v18c0 .8.7 1.5 1.5 1.5h21c.8 0 1.5-.7 1.5-1.5v-18c0-.8-.7-1.5-1.5-1.5zM25 25H7V11.5h18V25zM10 14.5v3h3v-3h-3zm4.5 0v3h3v-3h-3zM10 19v3h3v-3h-3zm4.5 0v3h3v-3h-3zm4.5-4.5v3h3v-3h-3zm0 4.5v3h3v-3h-3z" />
  </FillSvg>
);

export const CartArrowDownIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16.448 12.727c0.001 0.001 0.002 0.001 0.003 0.002 0.042 0.042 0.088 0.079 0.138 0.112 0.022 0.015 0.047 0.025 0.070 0.038 0.029 0.016 0.057 0.034 0.088 0.047s0.061 0.020 0.093 0.029c0.026 0.008 0.052 0.018 0.079 0.023 0.059 0.012 0.12 0.018 0.18 0.018s0.121-0.006 0.18-0.018c0.027-0.006 0.053-0.015 0.079-0.023 0.031-0.009 0.063-0.016 0.093-0.029s0.059-0.030 0.088-0.047c0.023-0.013 0.048-0.023 0.070-0.038 0.049-0.033 0.096-0.071 0.138-0.112 0.001-0.001 0.002-0.001 0.003-0.002l4.49-4.49c0.359-0.359 0.359-0.941 0-1.301s-0.941-0.359-1.3 0l-2.92 2.92v-8.378c0-0.508-0.412-0.92-0.92-0.92s-0.92 0.412-0.92 0.92v8.378l-2.92-2.921c-0.359-0.359-0.941-0.359-1.301 0s-0.359 0.941 0 1.301l4.49 4.49zM28.224 11.35c-0.169-0.265-0.461-0.426-0.776-0.426h-5.071c-0.508 0-0.92 0.412-0.92 0.92s0.412 0.92 0.92 0.92h3.616c-2.093 4.336-3.899 7.351-4.541 7.903h-8.773c-0.803-0.526-2.833-4.246-4.511-7.903h3.651c0.508 0 0.92-0.412 0.92-0.92s-0.412-0.92-0.92-0.92h-4.461c-0.549-1.232-1.307-2.426-2.599-2.861-1.1-0.371-2.342-0.128-3.796 0.743-0.436 0.261-0.577 0.826-0.316 1.262s0.826 0.578 1.262 0.316c0.95-0.569 1.711-0.764 2.263-0.578 0.784 0.264 1.311 1.351 1.722 2.38 0.002 0.006 0.006 0.011 0.008 0.017 0.001 0.003 0.002 0.007 0.003 0.010 0.011 0.025 1.092 2.491 2.351 4.925 1.081 2.091 1.879 3.371 2.499 4.155-0.969 0.68-1.687 1.82-1.687 2.948 0 0.813 0.372 1.523 1.049 1.999 0.664 0.467 1.611 0.705 2.815 0.705h10.588c0.508 0 0.92-0.412 0.92-0.92s-0.412-0.92-0.92-0.92h-10.588c-1.072 0-1.56-0.231-1.756-0.369-0.188-0.133-0.268-0.281-0.268-0.495 0-0.762 0.93-1.734 1.658-1.734h9.065c0.735 0 1.559-0.403 4.196-5.359 1.292-2.429 2.444-4.889 2.455-4.914 0.132-0.285 0.111-0.619-0.058-0.883zM18.078 29.652c0 0.974 0.789 1.763 1.763 1.763s1.763-0.789 1.763-1.763c0 0 0 0 0 0 0-0.974-0.789-1.763-1.763-1.763s-1.763 0.789-1.763 1.763zM12.080 29.652c0 0.974 0.789 1.763 1.763 1.763s1.763-0.789 1.763-1.763c0 0 0 0 0 0 0-0.974-0.789-1.763-1.763-1.763s-1.763 0.789-1.763 1.763z" />
  </FillSvg>
);

export const CartSlashIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M6.67 25.36c-0.224 0-0.448-0.085-0.618-0.256-0.341-0.341-0.341-0.895 0-1.235l20.663-20.663c0.341-0.341 0.894-0.341 1.235 0s0.341 0.895 0 1.236l-20.662 20.663c-0.171 0.17-0.394 0.256-0.618 0.256zM10.473 16.564c-0.307 0-0.604-0.161-0.764-0.448-1.489-2.672-2.923-5.94-2.983-6.078-0.118-0.27-0.092-0.582 0.069-0.829s0.436-0.396 0.731-0.396h9.121c0.483 0 0.874 0.391 0.874 0.874s-0.391 0.874-0.874 0.874h-7.767c0.555 1.203 1.455 3.088 2.355 4.703 0.235 0.421 0.084 0.954-0.338 1.189-0.135 0.075-0.28 0.111-0.424 0.111zM21.666 19.818h-4.634c-0.483 0-0.874-0.391-0.874-0.874s0.391-0.874 0.874-0.874h4.465c0.62-0.532 2.381-3.481 4.41-7.708-0.195-0.16-0.319-0.403-0.319-0.675 0-0.483 0.391-0.874 0.874-0.874h0.732c0.299 0 0.577 0.152 0.737 0.405s0.181 0.568 0.055 0.839c-0.011 0.023-1.105 2.361-2.333 4.669-2.505 4.709-3.287 5.091-3.986 5.091zM23.461 24.035h-10.060c-0.161 0-0.315-0.004-0.462-0.013-0.482-0.028-0.85-0.441-0.822-0.923s0.446-0.847 0.923-0.822c0.115 0.006 0.236 0.010 0.362 0.010h10.060c0.483 0 0.874 0.391 0.874 0.874s-0.391 0.874-0.874 0.874zM7.526 10.562c-0.347 0-0.675-0.208-0.811-0.549-0.391-0.977-0.891-2.010-1.636-2.261-0.524-0.177-1.247 0.008-2.15 0.549-0.414 0.248-0.95 0.114-1.199-0.301s-0.114-0.951 0.301-1.199c1.381-0.828 2.561-1.059 3.606-0.706 1.419 0.478 2.161 1.92 2.7 3.268 0.179 0.448-0.038 0.957-0.487 1.136-0.107 0.042-0.216 0.063-0.325 0.063zM21.641 26.608c0 0.925-0.75 1.675-1.675 1.675s-1.675-0.75-1.675-1.675c0-0.925 0.75-1.675 1.675-1.675s1.675 0.75 1.675 1.675zM15.942 26.608c0 0.925-0.75 1.675-1.675 1.675s-1.675-0.75-1.675-1.675c0-0.925 0.75-1.675 1.675-1.675s1.675 0.75 1.675 1.675z" />
  </FillSvg>
);

export const CartIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M10 22a1 1 0 100-2 1 1 0 000 2zM19 22a1 1 0 100-2 1 1 0 000 2zM1 1h4l3 13a2 2 0 002 2h9a2 2 0 002-2l2-8H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ChairInsideHouseIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 50 32" className={className}>
    <path d="M14 32H6a1 1 0 0 1-1-1V17.92a1 1 0 0 1 2 0V30h6v-6a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-1v6a1 1 0 0 1-1 1z" />
    <path d="M35 20.17c1.165.413 2 1.524 2 2.83v5a2 2 0 0 1-2 2v2h-2v-2H23v2h-2v-2a2 2 0 0 1-2-2v-5c0-1.306.835-2.417 2-2.83V19a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v1.17zm-2 0V19a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v1.17c1.165.413 2 1.524 2 2.83v1h6v-1c0-1.306.835-2.417 2-2.83zM21 28h14v-5a1 1 0 0 0-2 0v3H23v-3a1 1 0 0 0-2 0v5z" />
    <path d="M1 18.63a1 1 0 0 1-.67-.25A1 1 0 0 1 .26 17L15.2.33a1 1 0 0 1 1.48 0l10.06 11.2a1 1 0 0 1-1.48 1.34L15.94 2.5 1.74 18.3a1 1 0 0 1-.74.33z" />
  </FillSvg>
);

export const CheckCircleSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="currentColor" />
      <path
        d="m8 12 3 3 6-6"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </FillSvg>
);

export const CheckCircleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 12a7 7 0 1114 0 7 7 0 01-14 0zm7-9a9 9 0 100 18 9 9 0 000-18zm4 8a1 1 0 00-2-2l-3 4-1-2a1 1 0 00-2 2l2 2h2l4-4z"
    />
  </FillSvg>
);

export const CheckIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path d="M20 6L9 17L4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </StrokeSvg>
);

export const BrandedCheckCircleSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <circle cx="16" cy="16" r="16" fill="#E7F7E7" stroke="none" />
    <path
      d="M24 10 13 21l-5-5"
      stroke="#13AA13"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ClockIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6v6l4 2"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </FillSvg>
);

export const CloseIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M14.7 13.3c.4.4.4 1 0 1.4-.2.2-.4.3-.7.3s-.5-.1-.7-.3L8 9.4l-5.3 5.3c-.2.2-.4.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4L6.6 8 1.3 2.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0L8 6.6l5.3-5.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.4 8l5.3 5.3z" />
  </FillSvg>
);

export const CopyIcon = ({ className }: IStyledIcon) => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2">
      <rect width="13" height="13" x="9" y="9" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </g>
  </StrokeSvg>
);

export const DownloadIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 20 20" className={className}>
    <path d="M10 1v12m5-4l-5 5-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 15c0 2 1 4 4 4h10c3 0 4-2 4-4" strokeWidth="2" strokeLinecap="round" />
  </StrokeSvg>
);

export const ErrorTriangleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M30.036 29.617h-27.825c-0.367 0-0.707-0.194-0.894-0.51s-0.192-0.707-0.015-1.029l13.912-25.203c0.183-0.331 0.53-0.536 0.908-0.536s0.726 0.205 0.909 0.536l13.912 25.203c0.178 0.321 0.172 0.713-0.015 1.029s-0.526 0.51-0.894 0.51zM3.969 27.542h24.308l-12.154-22.018-12.154 22.018zM13.345 21.402v1.304h-0.523v-1.304h-1.827v-0.614l1.918-3.529h0.424v3.704h0.731v0.44h-0.723zM12.822 18.305l-1.453 2.657h1.453v-2.657zM17.014 22.316c-0.249 0.324-0.581 0.474-1.013 0.474-1.063 0-1.52-0.78-1.52-2.607 0-0.357 0.025-0.748 0.066-1.113 0.066-0.631 0.183-1.029 0.374-1.304 0.241-0.34 0.565-0.49 1.055-0.49 0.639 0 1.079 0.307 1.245 0.872 0.158 0.515 0.233 1.246 0.233 2.076 0 1.055-0.125 1.686-0.44 2.093zM16.632 18.089c-0.116-0.274-0.34-0.415-0.656-0.415-0.382 0-0.614 0.199-0.739 0.648-0.133 0.457-0.199 1.105-0.199 1.81 0 0.847 0.1 1.561 0.274 1.885 0.125 0.241 0.374 0.382 0.665 0.382 0.656 0 0.93-0.664 0.93-2.267 0-0.847-0.108-1.669-0.274-2.043zM20.236 21.402v1.304h-0.523v-1.304h-1.826v-0.614l1.918-3.529h0.423v3.704h0.731v0.44h-0.723zM19.712 18.305l-1.453 2.657h1.453v-2.657z" />
  </FillSvg>
);

export const EnvelopeOpenIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.721 8.074h-1.265v-3.862c0-0.586-0.48-1.066-1.066-1.066h-18.783c-0.586 0-1.066 0.48-1.066 1.066v3.863h-1.264c-1.616 0-2.93 1.314-2.93 2.93v14.918c0 1.616 1.314 2.93 2.93 2.93h23.442c1.616 0 2.93-1.314 2.93-2.93v-14.918c0-1.616-1.314-2.931-2.93-2.931zM27.721 9.673c0.698 0 1.255 0.544 1.311 1.227l-2.591 1.769c0.003-0.036 0.016-0.075 0.016-0.109v-2.887h1.265zM4.279 9.673h1.264v2.887c0 0.034 0.014 0.074 0.016 0.109l-2.59-1.767c0.055-0.684 0.613-1.229 1.311-1.229zM27.721 27.254h-23.442c-0.734 0-1.332-0.598-1.332-1.332v-13.101l8.21 5.602-5.151 4.155c-0.344 0.278-0.397 0.78-0.12 1.124 0.158 0.196 0.389 0.297 0.622 0.297 0.177 0 0.354-0.059 0.501-0.177l5.527-4.458 3.012 2.055c0.135 0.093 0.293 0.14 0.451 0.14s0.314-0.047 0.451-0.14l3.013-2.055 5.526 4.458c0.148 0.118 0.325 0.177 0.502 0.177 0.233 0 0.465-0.102 0.622-0.297 0.277-0.343 0.223-0.846-0.12-1.124l-5.15-4.155 8.21-5.602v13.101c0 0.735-0.597 1.332-1.332 1.332z" />
  </FillSvg>
);

export const EnvelopeSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.2,6.1L27.2,6.1H4.9c-1.5,0-2.8,1.3-2.8,2.8v14.2c0,1.5,1.3,2.8,2.8,2.8h22.3c1.5,0,2.8-1.3,2.8-2.8V8.9 C30,7.4,28.7,6.1,27.2,6.1z M24.6,21.1l-5.3-4.2l-2.9,2C16.3,18.9,16.2,19,16,19s-0.3,0-0.4-0.1l-2.9-2l-5.3,4.2 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.6-0.3c-0.3-0.3-0.2-0.8,0.1-1.1l4.9-4l-7.8-5.3v-0.4c0-0.4,0.1-0.8,0.3-1.2c0,0,0,0,0,0 L16,17.3L28.2,9c0.2,0.4,0.3,0.8,0.3,1.2v0.4L20.6,16l4.9,4c0.3,0.3,0.4,0.7,0.1,1.1c-0.2,0.2-0.4,0.3-0.6,0.3 C24.9,21.3,24.7,21.3,24.6,21.1z" />
  </FillSvg>
);

export const EnvelopeIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.198 6.13h-22.34c-1.54 0-2.793 1.252-2.793 2.793v14.216c0 1.54 1.252 2.793 2.793 2.793h22.34c1.54 0 2.793-1.252 2.793-2.793v-14.216c0-1.54-1.252-2.793-2.792-2.793zM4.858 7.653h22.34c0.665 0 1.197 0.519 1.249 1.171l-12.419 8.473-12.42-8.473c0.053-0.652 0.585-1.171 1.25-1.171zM27.198 24.408h-22.34c-0.7 0-1.269-0.569-1.269-1.269v-12.485l7.824 5.338-4.908 3.96c-0.327 0.265-0.379 0.743-0.115 1.071 0.151 0.186 0.371 0.284 0.593 0.284 0.169 0 0.337-0.056 0.478-0.169l5.267-4.249 2.872 1.959c0.13 0.088 0.28 0.133 0.429 0.133s0.299-0.045 0.429-0.133l2.871-1.959 5.267 4.249c0.141 0.113 0.309 0.169 0.478 0.169 0.222 0 0.442-0.097 0.593-0.284 0.264-0.327 0.212-0.806-0.115-1.071l-4.908-3.96 7.824-5.339v12.485c0.001 0.7-0.568 1.269-1.268 1.269z" />
  </FillSvg>
);

export const ExclamationCircleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="2.8 2.8 26.37 26.37" className={className}>
    <path d="M14.482 21.893c0-0.857 0.694-1.551 1.551-1.551s1.551 0.694 1.551 1.551c0 0.857-0.694 1.551-1.551 1.551s-1.551-0.694-1.551-1.551zM16.033 2.838c-7.271 0-13.187 5.916-13.187 13.187s5.916 13.187 13.187 13.187 13.187-5.916 13.187-13.187c0-7.271-5.916-13.187-13.187-13.187zM16.033 27.203c-6.163 0-11.178-5.015-11.178-11.178s5.015-11.178 11.178-11.178c6.164 0 11.178 5.015 11.178 11.178s-5.014 11.178-11.178 11.178zM16.033 8.308c-0.555 0-1.004 0.45-1.004 1.004v8.227c0 0.555 0.45 1.004 1.004 1.004s1.004-0.45 1.004-1.004v-8.227c0-0.555-0.45-1.004-1.004-1.004z" />
  </FillSvg>
);

export const ExclamationTriangleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M15.951 19.663c-0.457 0-0.828-0.37-0.828-0.828v-4.357c0-0.457 0.37-0.828 0.828-0.828s0.828 0.37 0.828 0.828v4.357c0 0.457-0.371 0.828-0.828 0.828zM15.952 22.906c-0.305 0-0.606-0.126-0.821-0.341s-0.338-0.514-0.338-0.818 0.122-0.606 0.338-0.821c0.431-0.43 1.209-0.43 1.639 0 0.215 0.215 0.341 0.516 0.341 0.821s-0.126 0.603-0.341 0.818c-0.215 0.215-0.513 0.341-0.818 0.341zM27.049 27.070h-22.196c-0.352 0-0.677-0.186-0.855-0.489s-0.184-0.677-0.014-0.985l11.098-20.105c0.175-0.317 0.508-0.513 0.87-0.513s0.695 0.197 0.87 0.513l11.098 20.105c0.17 0.308 0.165 0.683-0.014 0.985s-0.504 0.489-0.856 0.489zM6.536 25.083h18.83l-9.415-17.056-9.415 17.056z" />
  </FillSvg>
);

export const FacebookIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M9.7 4v2.4h3.2l-.8 3.2H9.7V16H6.5V9.6H4.1V6.4h2.4V4c0-1.1.4-2.1 1.2-2.8C8.4.4 9.4 0 10.5 0h2.4v3.2h-2.4c-.2 0-.4.1-.6.2-.1.2-.2.4-.2.6z" />
  </FillSvg>
);

export const FilterIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M15.9 1.1c-.1-.3-.4-.4-.7-.4H.7C.4.7.2.9 0 1.1c-.1.3 0 .6.2.8l5.6 6.7v4.5c0 .3.2.5.4.7l2.9 1.5c.1.1.2.1.3.1.1 0 .3 0 .4-.1.2-.1.3-.4.3-.6V8.6l5.6-6.7c.3-.2.4-.5.2-.8zm-7 6.8c-.1.1-.2.3-.2.4v5l-1.5-.7V8.3c0-.2-.1-.3-.2-.5L2.3 2.2h11.4L8.9 7.9z" />
  </FillSvg>
);

export const FilterAltIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 16 16" className={className}>
    <path
      d="M5 14V8M5 5V2M11 14v-3M11 8V2M3 5h4M9 11h4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const FlipToBackIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M13,11h-2v2h2V11z M13,15h-2v2h2V15z M13,7c-1.1,0-2,0.9-2,2h2V7z M17,19h-2v2h2V19z M23,7v2h2C25,7.9,24.1,7,23,7z M17,7 h-2v2h2V7z M13,21v-2h-2C11,20.1,11.9,21,13,21z M23,17h2v-2h-2V17z M23,13h2v-2h-2V13z M23,21c1.1,0,2-0.9,2-2h-2V21z M9,11H7v12 c0,1.1,0.9,2,2,2h12v-2H9V11z M19,9h2V7h-2V9z M19,21h2v-2h-2V21z" />
  </FillSvg>
);

export const FlipToFrontIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M7,17h2v-2H7V17z M7,21h2v-2H7V21z M9,25v-2H7C7,24.1,7.9,25,9,25z M7,13h2v-2H7V13z M19,25h2v-2h-2V25z M23,7H13 c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h10c1.1,0,2-0.9,2-2V9C25,7.9,24.1,7,23,7z M23,19H13V9h10V19z M15,25h2v-2h-2V25z M11,25h2v-2 h-2V25z" />
  </FillSvg>
);

export const ForbiddenIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M15.951 4.581c-6.323 0-11.466 5.144-11.466 11.466s5.144 11.466 11.466 11.466c6.322 0 11.466-5.144 11.466-11.466s-5.144-11.466-11.466-11.466zM21.64 8.793l-5.934 5.934-5.714-5.714c1.609-1.365 3.689-2.191 5.959-2.191 2.145 0 4.12 0.738 5.689 1.971zM8.697 10.358l5.688 5.689-5.689 5.688c-1.233-1.568-1.971-3.544-1.971-5.688s0.738-4.12 1.971-5.689zM9.992 23.081l5.714-5.713 5.934 5.934c-1.568 1.233-3.544 1.971-5.688 1.971-2.271 0-4.351-0.826-5.96-2.191zM22.985 22.006l-5.959-5.96 5.96-5.959c1.365 1.609 2.191 3.689 2.191 5.959s-0.826 4.35-2.191 5.96z" />
  </FillSvg>
);

export const FormChecklistIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M28.3,29c-0.5,0-0.9-0.4-0.9-0.9V4.5H4.7v23.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V3.6c0-0.5,0.4-0.9,0.9-0.9h24.5 c0.5,0,0.9,0.4,0.9,0.9v24.5C29.2,28.7,28.8,29,28.3,29L28.3,29z M14.7,14.6c-0.2,0-0.4-0.1-0.5-0.2l-2.9-2.9c-0.3-0.3-0.3-0.7,0-1 s0.7-0.3,1,0l2.4,2.4l5-5c0.3-0.3,0.7-0.3,1,0s0.3,0.7,0,1l-5.5,5.5C15.1,14.5,14.9,14.6,14.7,14.6L14.7,14.6z M23,25.7H12.4 c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H23c0.4,0,0.7,0.3,0.7,0.7S23.4,25.7,23,25.7z M9.2,26c-0.3,0-0.5-0.1-0.7-0.3 c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7c0.4-0.4,1.1-0.4,1.4,0c0.2,0.2,0.3,0.5,0.3,0.7s-0.1,0.5-0.3,0.7C9.7,25.9,9.4,26,9.2,26 L9.2,26z M23,18.8H12.4c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H23c0.4,0,0.7,0.3,0.7,0.7S23.4,18.8,23,18.8z M9.2,19.1 c-0.3,0-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7c0.4-0.4,1.1-0.4,1.4,0c0.2,0.2,0.3,0.5,0.3,0.7s-0.1,0.5-0.3,0.7 C9.7,19,9.4,19.1,9.2,19.1L9.2,19.1z M9.2,22.6c-0.3,0-0.5-0.1-0.7-0.3s-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7 c0.4-0.4,1.1-0.4,1.4,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7S9.4,22.6,9.2,22.6L9.2,22.6z M23,22.3H12.4 c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7H23c0.4,0,0.7,0.3,0.7,0.7S23.4,22.3,23,22.3z" />
  </FillSvg>
);

export const FormChecklistAltIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.4,29.2c-0.6,0-1-0.4-1-1V10.9l-5.7-5.7h-15v23c0,0.6-0.4,1-1,1s-1-0.4-1-1v-24c0-0.6,0.4-1,1-1h16.4 c0.3,0,0.5,0.1,0.7,0.3l6.2,6.3c0.2,0.2,0.3,0.4,0.3,0.7v17.7C28.4,28.8,27.9,29.2,27.4,29.2L27.4,29.2z M10.3,14.5 c-0.2,0-0.4-0.1-0.6-0.2l-1.2-1.2c-0.3-0.3-0.3-0.9,0-1.2s0.9-0.3,1.2,0l0.6,0.6l1.3-1.3c0.3-0.3,0.9-0.3,1.2,0s0.3,0.9,0,1.2 l-1.9,1.9C10.7,14.4,10.5,14.5,10.3,14.5L10.3,14.5z M21.4,14h-6.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h6.5c0.6,0,1,0.4,1,1S22,14,21.4,14z  M21.4,19.1h-6.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h6.5c0.6,0,1,0.4,1,1S22,19.1,21.4,19.1z M10.6,19.2c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.5-0.3-0.8s0.1-0.6,0.3-0.8c0.4-0.4,1.2-0.4,1.6,0c0.2,0.2,0.3,0.5,0.3,0.8s-0.1,0.6-0.3,0.8 C11.2,19.1,10.9,19.2,10.6,19.2z M10.6,24.3c-0.3,0-0.6-0.1-0.8-0.3s-0.3-0.5-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.4-0.4,1.2-0.4,1.6,0 c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.1,0.6-0.3,0.8C11.2,24.2,10.9,24.3,10.6,24.3z M21.4,24.1h-6.5c-0.6,0-1-0.4-1-1s0.4-1,1-1h6.5 c0.6,0,1,0.4,1,1S22,24.1,21.4,24.1z" />
  </FillSvg>
);

export const FormPageIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M28.3,29.2c-0.5,0-0.9-0.4-0.9-0.9V4.6H4.6v23.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V3.8c0-0.5,0.4-0.9,0.9-0.9h24.5 c0.5,0,0.9,0.4,0.9,0.9v24.5C29.2,28.8,28.8,29.2,28.3,29.2z M23.9,14.6H8.1c-0.4,0-0.7-0.3-0.7-0.7V8.1c0-0.4,0.3-0.7,0.7-0.7h15.8 c0.4,0,0.7,0.3,0.7,0.7v5.8C24.7,14.3,24.3,14.6,23.9,14.6z M8.9,13.2h14.3V8.8H8.9C8.9,8.8,8.9,13.2,8.9,13.2z M23.9,25.5h-5 c-0.4,0-0.7-0.3-0.7-0.7v-6.7c0-0.4,0.3-0.7,0.7-0.7h5c0.4,0,0.7,0.3,0.7,0.7v6.7C24.7,25.2,24.3,25.5,23.9,25.5z M19.7,24.1h3.5 v-5.3h-3.5V24.1z M14.4,18.8H8.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h6.3c0.4,0,0.7,0.3,0.7,0.7S14.8,18.8,14.4,18.8z  M14.4,22.2H8.1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h6.3c0.4,0,0.7,0.3,0.7,0.7S14.8,22.2,14.4,22.2z M14.4,25.5H8.1 c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h6.3c0.4,0,0.7,0.3,0.7,0.7S14.8,25.5,14.4,25.5z" />
  </FillSvg>
);

export const GooglePlusSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M11.385 20.734c-0.192 0-1.342 0.040-2.238 0.334-0.47 0.17-1.831 0.673-1.831 2.165 0 1.491 1.469 2.563 3.748 2.563 2.046 0 3.132-0.97 3.132-2.272 0-1.070-0.701-1.636-2.318-2.771-0.172-0.020-0.279-0.020-0.493-0.020zM10.34 11.362c-0.554 0-1.149 0.273-1.494 0.697-0.362 0.436-0.471 1.004-0.471 1.548 0 1.408 0.838 3.743 2.667 3.743 0.536 0 1.109-0.255 1.453-0.591 0.487-0.485 0.529-1.155 0.529-1.529 0-1.515-0.915-3.868-2.684-3.868zM2.050 8.489v15.995c0 3.006 2.461 5.466 5.469 5.466h16.963c3.008 0 5.469-2.461 5.469-5.466v-15.995h-27.901zM14.903 14.227c0 1.554-0.896 2.326-1.792 3.017-0.276 0.275-0.6 0.572-0.6 1.033s0.324 0.715 0.559 0.901l0.766 0.589c0.937 0.778 1.787 1.497 1.787 2.942 0 1.974-1.94 3.969-5.604 3.969-3.091 0-4.579-1.449-4.579-3.004 0-0.755 0.383-1.827 1.644-2.563 1.317-0.798 3.107-0.904 4.068-0.97-0.299-0.375-0.641-0.773-0.641-1.427 0-0.352 0.107-0.564 0.215-0.818-0.237 0.020-0.471 0.042-0.684 0.042-2.258 0-3.541-1.663-3.541-3.303 0-0.967 0.449-2.044 1.369-2.816 1.21-0.991 2.663-1.165 3.811-1.165h4.389l-1.365 0.696h-1.32c0.491 0.469 1.517 1.278 1.517 2.876zM26.73 20.326h-3.212v3.186h-2.171v-3.186h-3.2v-2.188h3.2v-3.211h2.171v3.211h3.212v2.188zM29.925 7.282c-0.126-2.894-2.517-5.231-5.444-5.231h-16.963c-2.929 0-5.317 2.337-5.443 5.231h27.851z" />
  </FillSvg>
);

export const HeadsetIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M31.488 14.87c0-2.812-1.536-4.963-3.8-5.635-1.949-4.891-6.592-8.156-11.687-8.156s-9.739 3.265-11.688 8.156c-2.264 0.672-3.8 2.823-3.8 5.635 0 3.404 2.234 5.875 5.31 5.875h0.267v-0.019c0.933-0.129 1.652-0.931 1.652-1.899v-7.916c0-0.955-0.701-1.744-1.614-1.891 1.874-3.85 5.702-6.367 9.873-6.367s7.999 2.517 9.873 6.367c-0.914 0.146-1.614 0.937-1.614 1.891v7.916c0 0.967 0.72 1.77 1.652 1.9l0.267 0.019c0.198 0 0.383-0.038 0.574-0.058-0.989 3.986-3.833 5.729-4.154 5.833h-1.395c-0.418-1.614-2.081-2.827-4.072-2.827-2.305 0-4.18 1.621-4.18 3.614s1.874 3.614 4.18 3.614c1.991 0 3.654-1.212 4.072-2.827h1.393c0.917 0 4.912-2.541 5.858-7.876 1.837-0.895 3.033-2.868 3.033-5.351zM6.166 18.827c0 0.189-0.153 0.343-0.343 0.343-2.565 0-3.735-2.229-3.735-4.3s1.169-4.301 3.735-4.301c0.19 0 0.343 0.153 0.343 0.343v7.915zM17.131 29.347c-1.437 0-2.604-0.915-2.604-2.039s1.168-2.039 2.604-2.039c1.436 0 2.603 0.915 2.603 2.039s-1.168 2.039-2.603 2.039zM26.177 19.17c-0.19 0-0.343-0.153-0.343-0.343v-7.916c0-0.189 0.153-0.343 0.343-0.343 2.565 0 3.735 2.229 3.735 4.301s-1.17 4.301-3.735 4.301z" />
  </FillSvg>
);

export const HeartSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M28.597 8.658c-0.995-2.269-3.112-3.624-5.662-3.624-1.626 0-4.089 0.559-6.858 3.105-2.769-2.546-5.232-3.105-6.858-3.105-2.55 0-4.667 1.355-5.662 3.624-1.325 3.022-0.331 6.766 2.661 10.014 4.102 4.454 9.095 8.172 9.305 8.329 0.165 0.122 0.36 0.183 0.554 0.183s0.39-0.061 0.554-0.183c0.211-0.156 5.204-3.874 9.305-8.329 2.991-3.248 3.985-6.992 2.66-10.014v0z" />
  </FillSvg>
);

export const HeartIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M28.597 8.658c-0.995-2.269-3.112-3.624-5.662-3.624-1.626 0-4.089 0.559-6.858 3.105-2.769-2.546-5.232-3.105-6.858-3.105-2.55 0-4.667 1.355-5.662 3.624-1.325 3.022-0.331 6.766 2.661 10.014 4.102 4.454 9.095 8.172 9.305 8.329 0.165 0.122 0.36 0.183 0.554 0.183s0.39-0.061 0.554-0.183c0.211-0.156 5.204-3.874 9.305-8.329 2.991-3.248 3.985-6.992 2.66-10.014zM24.567 17.411c-3.201 3.476-7.071 6.573-8.49 7.671-1.418-1.097-5.286-4.192-8.489-7.671-2.475-2.688-3.344-5.681-2.325-8.005 0.689-1.572 2.168-2.51 3.956-2.51 1.977 0 4.177 1.133 6.193 3.191 0.35 0.358 0.98 0.358 1.33 0 2.017-2.057 4.216-3.191 6.193-3.191 1.788 0 3.267 0.938 3.956 2.51 1.019 2.325 0.15 5.317-2.325 8.005z" />
  </FillSvg>
);

export const HelpCircleIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M12 22a10 10 0 100-20 10 10 0 000 20z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9a3 3 0 016 1c0 2-3 3-3 3M12 17h0"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const HomeIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M23.91 30.592h-4.664c-0.874 0-1.585-0.711-1.585-1.584v-5.13h-2.486v5.13c0 0.873-0.711 1.584-1.585 1.584h-5.441c-0.874 0-1.585-0.711-1.585-1.584v-11.936c0-0.483 0.392-0.875 0.875-0.875s0.875 0.392 0.875 0.875v11.769h5.108v-5.13c0-0.874 0.711-1.585 1.584-1.585h2.819c0.873 0 1.584 0.711 1.584 1.585v5.13h4.331v-11.769c0-0.483 0.392-0.875 0.875-0.875s0.875 0.392 0.875 0.875v11.936c0.001 0.874-0.71 1.584-1.584 1.584zM29.198 18.448c-0.246 0-0.49-0.103-0.663-0.304l-12.505-14.497-12.505 14.497c-0.316 0.367-0.869 0.407-1.235 0.091s-0.407-0.869-0.091-1.235l13.168-15.266c0.166-0.193 0.408-0.304 0.663-0.304s0.497 0.111 0.663 0.304l13.168 15.266c0.316 0.366 0.275 0.919-0.091 1.235-0.166 0.143-0.37 0.213-0.572 0.213z" />
  </FillSvg>
);

export const HomeSlashIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <g>
      <path d="M23.92 4.81a.873.873 0 0 0-1.23-1.24l-2.78 2.79L14.7.3l-.09-.09a.87.87 0 0 0-1.23.09L.21 15.57a.88.88 0 0 0 1.33 1.14L14.01 2.22l4.66 5.35L6.32 19.95v-4.31a.875.875 0 0 0-1.75 0v6.06l-3.7 3.7a.87.87 0 1 0 1.23 1.23zM27.87 15.57l-5-5.85a.88.88 0 1 0-1.33 1.14l5 5.85a.88.88 0 1 0 1.33-1.14zM22.62 14.77a.88.88 0 0 0-.87.88v11.76h-4.33v-5.13a1.59 1.59 0 0 0-1.59-1.59h-2.82a1.58 1.58 0 0 0-1.58 1.58v5.13H6.32v-1.16a.875.875 0 0 0-1.75 0v1.33a1.58 1.58 0 0 0 1.58 1.58h5.44a1.58 1.58 0 0 0 1.59-1.58v-5.12h2.49v5.12a1.58 1.58 0 0 0 1.58 1.58h4.66a1.58 1.58 0 0 0 1.59-1.58V15.64a.87.87 0 0 0-.88-.87z" />
    </g>
  </FillSvg>
);

export const InfoIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M14.482 10.156c0 0.857 0.694 1.551 1.551 1.551s1.551-0.694 1.551-1.551c0-0.857-0.694-1.551-1.551-1.551s-1.551 0.694-1.551 1.551zM16.033 29.211c-7.271 0-13.187-5.916-13.187-13.187s5.916-13.187 13.187-13.187 13.187 5.916 13.187 13.187c0 7.271-5.916 13.187-13.187 13.187zM16.033 4.846c-6.163 0-11.178 5.015-11.178 11.178s5.015 11.178 11.178 11.178c6.164 0 11.178-5.015 11.178-11.178s-5.014-11.178-11.178-11.178zM16.033 23.741c-0.555 0-1.004-0.45-1.004-1.004v-8.227c0-0.555 0.45-1.004 1.004-1.004s1.004 0.45 1.004 1.004v8.227c0 0.555-0.45 1.004-1.004 1.004z" />
  </FillSvg>
);

export const InfoSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16,2.8C8.7,2.8,2.8,8.7,2.8,16S8.7,29.2,16,29.2S29.2,23.3,29.2,16S23.3,2.8,16,2.8z M16,23.7c-0.6,0-1-0.5-1-1v-8.2 c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1v8.2C17,23.3,16.6,23.7,16,23.7z M16,11.7c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 S16.9,11.7,16,11.7z" />
  </FillSvg>
);

export const InstagramIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M11.6 0H4.4C2 0 0 2 0 4.4v7.3C0 14 2 16 4.4 16h7.3c2.4 0 4.4-2 4.4-4.4V4.4C16 2 14 0 11.6 0zm2.9 11.6c0 1.6-1.3 2.9-2.9 2.9H4.4c-1.6 0-2.9-1.3-2.9-2.9V4.4c0-1.6 1.3-2.9 2.9-2.9h7.3c1.6 0 2.9 1.3 2.9 2.9v7.2zm-3.9-6.2c-.6-.6-1.3-.9-2-1-.8-.1-1.6 0-2.2.3-.7.4-1.3.9-1.6 1.6-.4.7-.5 1.5-.4 2.2.1.8.5 1.4 1 2 .5.5 1.2.9 2 1H8c.6 0 1.1-.1 1.6-.4.7-.3 1.2-.9 1.6-1.6.4-.7.5-1.4.4-2.2-.1-.6-.4-1.4-1-1.9zM10 9c-.2.4-.6.7-1 .9-.4.2-.9.3-1.3.2-.5-.1-.9-.3-1.2-.6-.3-.3-.5-.7-.6-1.2-.1-.4 0-.9.2-1.3s.5-.8.9-1c.3-.2.7-.2 1-.2h.3c.5.1.9.3 1.2.6.3.3.5.8.6 1.2.2.5.1 1-.1 1.4zm2.7-5c0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7s.3-.7.7-.7c.4 0 .7.3.7.7z" />
  </FillSvg>
);

export const ListUlIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.075 25.003h-16.955c-0.627 0-1.136-0.508-1.136-1.136s0.508-1.136 1.136-1.136h16.955c0.627 0 1.136 0.508 1.136 1.136s-0.508 1.136-1.136 1.136zM4.971 25.165c-0.341 0-0.675-0.14-0.918-0.38-0.24-0.243-0.38-0.578-0.38-0.918 0-0.344 0.139-0.679 0.38-0.918s0.577-0.38 0.918-0.38c0.341 0 0.675 0.139 0.918 0.38 0.24 0.24 0.38 0.574 0.38 0.918 0 0.341-0.139 0.675-0.38 0.918-0.244 0.24-0.578 0.38-0.918 0.38zM27.075 9.331h-16.955c-0.627 0-1.136-0.508-1.136-1.136s0.508-1.136 1.136-1.136h16.955c0.627 0 1.136 0.508 1.136 1.136s-0.508 1.136-1.136 1.136zM4.971 9.493c-0.341 0-0.675-0.139-0.918-0.38-0.24-0.243-0.38-0.578-0.38-0.918 0-0.344 0.139-0.678 0.38-0.918s0.574-0.38 0.918-0.38c0.341 0 0.675 0.139 0.918 0.38 0.24 0.243 0.38 0.577 0.38 0.918s-0.139 0.675-0.38 0.918c-0.244 0.24-0.578 0.38-0.918 0.38zM4.971 17.329c-0.344 0-0.678-0.139-0.918-0.38-0.24-0.243-0.38-0.578-0.38-0.918 0-0.344 0.139-0.678 0.38-0.918s0.574-0.38 0.918-0.38c0.341 0 0.675 0.139 0.918 0.38 0.24 0.24 0.38 0.578 0.38 0.918s-0.139 0.675-0.38 0.918c-0.244 0.24-0.578 0.38-0.918 0.38zM27.075 17.167h-16.955c-0.627 0-1.136-0.508-1.136-1.136s0.508-1.136 1.136-1.136h16.955c0.627 0 1.136 0.508 1.136 1.136s-0.508 1.136-1.136 1.136z" />
  </FillSvg>
);

export const LocationArrowIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.338 14.451l-21.759-10.688c-0.008-0.004-0.016-0.005-0.024-0.009-0.044-0.020-0.089-0.036-0.135-0.050-0.026-0.008-0.052-0.018-0.078-0.024-0.042-0.010-0.084-0.015-0.126-0.020-0.031-0.004-0.062-0.009-0.093-0.010-0.038-0.001-0.077 0.002-0.115 0.005-0.035 0.003-0.070 0.004-0.104 0.010s-0.068 0.015-0.102 0.024c-0.039 0.010-0.077 0.020-0.114 0.034-0.011 0.004-0.022 0.005-0.033 0.010-0.021 0.009-0.039 0.022-0.059 0.032-0.037 0.018-0.073 0.036-0.107 0.058-0.029 0.018-0.056 0.039-0.084 0.059-0.031 0.023-0.061 0.048-0.090 0.075-0.026 0.024-0.049 0.050-0.072 0.076-0.025 0.028-0.049 0.057-0.072 0.088s-0.040 0.062-0.059 0.094c-0.013 0.022-0.028 0.040-0.039 0.063-0.006 0.012-0.008 0.024-0.013 0.035-0.014 0.033-0.025 0.066-0.037 0.099-0.013 0.038-0.026 0.075-0.035 0.113-0.007 0.029-0.010 0.059-0.014 0.089-0.006 0.043-0.013 0.086-0.014 0.129-0.001 0.027 0.002 0.055 0.003 0.082 0.002 0.046 0.005 0.092 0.013 0.137 0.004 0.025 0.012 0.050 0.018 0.075 0.012 0.048 0.025 0.095 0.043 0.141 0.003 0.008 0.004 0.016 0.007 0.025l9.264 22.402c0.174 0.42 0.583 0.694 1.038 0.695 0.001 0 0.002 0 0.003 0 0.454 0 0.863-0.272 1.038-0.69l3.434-8.185 8.39-2.899c0.429-0.148 0.728-0.541 0.756-0.994s-0.22-0.88-0.628-1.080zM17.608 17.461c-0.009 0.003-0.016 0.008-0.025 0.012-0.041 0.015-0.080 0.035-0.119 0.055-0.028 0.014-0.056 0.027-0.082 0.043-0.034 0.021-0.065 0.046-0.097 0.071-0.026 0.021-0.053 0.040-0.078 0.062-0.027 0.026-0.052 0.055-0.076 0.083-0.023 0.027-0.048 0.053-0.068 0.081s-0.037 0.059-0.055 0.089c-0.020 0.035-0.041 0.069-0.057 0.105-0.004 0.009-0.011 0.017-0.015 0.027l-2.583 6.157-7.091-17.147 16.655 8.181-6.31 2.181z" />
  </FillSvg>
);

export const LogInIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M15 3h4c.5304 0 1.0391.21071 1.4142.58579C20.7893 3.96086 21 4.46957 21 5v14c0 .5304-.2107 1.0391-.5858 1.4142S19.5304 21 19 21h-4M10 17l5-5-5-5M15 12H3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const MailIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M13.8 1.5H2.2C1 1.5 0 2.4 0 3.6v8.7c0 1.2 1 2.2 2.2 2.2h11.6c1.2 0 2.2-1 2.2-2.2V3.6c0-1.2-1-2.1-2.2-2.1zM2.2 2.9h11.6c.3 0 .5.2.6.4L8 7.8 1.5 3.3c.2-.2.4-.4.7-.4zm11.6 10.2H2.2c-.4 0-.7-.3-.7-.7V5l6.1 4.3c.1.1.3.2.4.2.1 0 .3 0 .4-.1L14.5 5v7.3c0 .5-.3.8-.7.8z" />
  </FillSvg>
);

export const MapMarkerIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16.014 28.743c-0.355 0-0.687-0.179-0.882-0.477-0.301-0.46-7.371-11.332-7.371-17.046 0-3.44 1.737-5.391 3.195-6.422 1.726-1.221 3.744-1.656 5.058-1.656s3.332 0.435 5.058 1.656c1.458 1.031 3.195 2.982 3.195 6.422 0 5.714-7.070 16.586-7.371 17.046-0.195 0.297-0.527 0.477-0.882 0.477zM16.014 5.25c-1.594 0-6.146 1.097-6.146 5.97 0 2.063 1.2 5.444 3.471 9.78 0.99 1.89 1.988 3.583 2.675 4.706 0.686-1.123 1.684-2.816 2.675-4.706 2.271-4.335 3.471-7.717 3.471-9.78 0-4.873-4.551-5.97-6.145-5.97zM16.011 15.344c-1.975 0-3.583-1.607-3.583-3.583s1.607-3.583 3.583-3.583 3.583 1.607 3.583 3.583c0 1.976-1.608 3.583-3.583 3.583zM16.011 9.984c-0.98 0-1.777 0.797-1.777 1.777s0.797 1.777 1.777 1.777c0.98 0 1.777-0.797 1.777-1.777s-0.797-1.777-1.777-1.777z" />
  </FillSvg>
);

export const MapMarkerSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M21.1,4.8c-1.7-1.2-3.7-1.7-5.1-1.7c-1.3,0-3.3,0.4-5.1,1.7c-1.5,1-3.2,3-3.2,6.4c0,5.7,7.1,16.6,7.4,17 c0.2,0.3,0.5,0.5,0.9,0.5c0.4,0,0.7-0.2,0.9-0.5c0.3-0.5,7.4-11.3,7.4-17C24.3,7.8,22.5,5.8,21.1,4.8z M12.4,11.8 c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6S18,15.3,16,15.3C14,15.3,12.4,13.7,12.4,11.8z" />
  </FillSvg>
);

export const MenuIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M4 16h24M4 8h24M4 24h24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const MinusCircleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M15.951 27.513c-6.323 0-11.466-5.144-11.466-11.466s5.144-11.466 11.466-11.466 11.466 5.144 11.466 11.466c0 6.322-5.144 11.466-11.466 11.466zM15.951 6.821c-5.087 0-9.226 4.139-9.226 9.226s4.139 9.226 9.226 9.226c5.087 0 9.226-4.139 9.226-9.226s-4.139-9.226-9.226-9.226zM21.404 16.98h-10.906c-0.516 0-0.934-0.418-0.934-0.934s0.418-0.934 0.934-0.934h10.906c0.516 0 0.934 0.418 0.934 0.934s-0.418 0.934-0.934 0.934z" />
  </FillSvg>
);

export const MinusIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M26.489 17.233h-21.014c-0.684 0-1.239-0.555-1.239-1.239s0.554-1.239 1.239-1.239h21.014c0.684 0 1.239 0.555 1.239 1.239s-0.555 1.239-1.239 1.239z" />
  </FillSvg>
);

export const MioLogoIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M30.9 9.9c0.7 0.7 1.1 1.5 1.1 2.4v7.4c0 0.9-0.4 1.7-1.1 2.4s-1.5 1.1-2.4 1.1c-1.4 0-2.7 0-3.7 0s-1.8 0-2.4 0-0.9 0-1.2 0c-1.2 0-2-0.4-2.5-1.3l-0.2 0.3c-0.1 0.2-0.3 0.4-0.5 0.7s-0.6 0.3-0.9 0.3h-2c-0.4 0-0.7-0.1-1-0.4s-0.5-0.4-0.5-0.6c0-0.1-0.1-0.2-0.1-0.3l-0.3 0.3c-0.2 0.2-0.5 0.4-0.9 0.6s-1 0.3-1.5 0.3c-0.4 0-0.9-0.2-1.3-0.5l-0.1 0.1c-0.3 0.2-0.4 0.2-0.6 0.3s-0.5 0.1-0.7 0.1h-1.9c-0.4 0-0.8-0.2-1.2-0.5l-0.1 0.1c0 0.1-0.2 0.2-0.4 0.2-0.2 0.1-0.5 0.1-0.8 0.1-1.1 0-1.9-0.4-2.6-1.1s-1-1.5-1-2.3v-7.6c0-0.9 0.3-1.7 0.9-2.4s1.5-1 2.7-1c0.7 0 1.3 0.2 1.8 0.5 0.5 0.5 0.9 0.8 1.1 1.1 0.3 0.3 0.4 0.5 0.5 0.5 0 0 0.2-0.2 0.5-0.5s0.7-0.6 1.2-0.9c0.4-0.3 1-0.5 1.8-0.5 1.2 0 2.2 0.4 2.8 1.2l0.1-0.3c0.1-0.2 0.3-0.4 0.5-0.6 0.3-0.2 0.6-0.3 1-0.3h2c0.8 0 1.4 0.4 1.7 1.2l0.3-0.3c0.1-0.2 0.4-0.4 0.9-0.6 0.4-0.2 0.9-0.3 1.4-0.3h7.3c0.8 0 1.6 0.4 2.3 1.1v0zM13.3 12.3c0-0.7-0.3-1.3-0.8-1.8-0.6-0.5-1.2-0.8-1.9-0.8-0.6 0-1.2 0.2-1.6 0.5-0.4 0.4-0.8 0.7-1.1 1.1s-0.5 0.5-0.8 0.5-0.5-0.2-0.8-0.5c-0.3-0.4-0.7-0.7-1.1-1.1s-1-0.5-1.6-0.5c-0.8 0-1.4 0.3-1.9 0.8s-0.8 1.1-0.8 1.7v7.6c0 0.6 0.3 1.2 0.9 1.7s1.1 0.7 1.7 0.7c0.3 0 0.5-0.1 0.6-0.2 0.2-0.2 0.2-0.3 0.3-0.4 0-0.1 0-0.2 0-0.2v-7.5c0-0.3 0.2-0.5 0.5-0.5s0.5 0.2 0.5 0.5v7.6c0 0.4 0.3 0.6 0.8 0.6h1.7c0.6 0 0.9-0.2 0.9-0.6v-7.6c0-0.3 0.2-0.5 0.5-0.5s0.5 0.2 0.5 0.5v7.5c0 0 0 0.1 0 0.2s0.1 0.2 0.3 0.4c0.2 0.2 0.4 0.2 0.6 0.2 0.5 0 1.1-0.2 1.7-0.7s0.9-1 0.9-1.7c0-3 0-5.6 0-7.5v0zM17.7 10.6c0-0.2-0.1-0.4-0.2-0.6-0.2-0.2-0.3-0.2-0.6-0.2h-1.9c-0.2 0-0.4 0.1-0.6 0.2-0.2 0.2-0.2 0.3-0.2 0.6v1.9c0 0.2 0.1 0.4 0.2 0.6 0.2 0.2 0.3 0.2 0.6 0.2h1.9c0.2 0 0.4-0.1 0.6-0.2 0.2-0.2 0.2-0.3 0.2-0.6v-1.9zM17.7 15.1c0-0.3-0.1-0.5-0.2-0.6s-0.3-0.2-0.6-0.2h-1.9c-0.2 0-0.4 0.1-0.6 0.2-0.2 0.2-0.2 0.4-0.2 0.6v6.2c0 0.2 0.1 0.4 0.2 0.6 0.2 0.2 0.3 0.2 0.6 0.2h1.9c0.2 0 0.4-0.1 0.6-0.2 0.2-0.2 0.2-0.3 0.2-0.6v-6.2zM31.1 12.3c0-0.7-0.3-1.3-0.8-1.8-0.6-0.5-1.1-0.8-1.8-0.8-2.5 0-4.9 0-7.2 0-0.6 0-1.2 0.3-1.7 0.8-0.6 0.5-0.8 1.1-0.8 1.7v7.6c0 0.5 0.3 1.1 0.8 1.6s1.1 0.8 1.8 0.8h7.2c0.6 0 1.2-0.3 1.7-0.8 0.6-0.5 0.9-1 0.9-1.6l-0.1-7.5zM22.5 13.6c-0.2 0.2-0.4 0.6-0.4 1v2.8c0 0.4 0.1 0.7 0.4 0.9 0.2 0.3 0.5 0.4 0.9 0.4h2.8c0.4 0 0.7-0.1 1-0.4s0.4-0.6 0.4-0.9v-2.8c0-0.4-0.1-0.7-0.4-1s-0.6-0.4-1-0.4h-2.8c-0.3 0.1-0.6 0.2-0.9 0.4zM23.4 14.2h3c0.2 0 0.3 0.1 0.3 0.3v3.1c0 0.1-0.1 0.2-0.3 0.2h-3c-0.2 0-0.3-0.1-0.3-0.2v-3.1c0-0.2 0.1-0.3 0.3-0.3z" />
  </FillSvg>
);

export const PackageIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="m16.5 9.4-9-5.19M21 16V8c-.0004-.35073-.0929-.69519-.2685-.99884-.1755-.30365-.4278-.5558-.7315-.73116l-7-4c-.304-.17554-.6489-.26795-1-.26795-.3511 0-.696.09241-1 .26795l-7 4c-.30374.17536-.55602.42751-.73154.73116C3.09294 7.30481 3.00036 7.64927 3 8v8c.00036.3507.09294.6952.26846.9988.17552.3037.4278.5558.73154.7312l7 4c.304.1755.6489.2679 1 .2679.3511 0 .696-.0924 1-.2679l7-4c.3037-.1754.556-.4275.7315-.7312.1756-.3036.2681-.6481.2685-.9988Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.27002 6.96 12 12.01l8.73-5.05M12 22.08V12"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const PageIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M26 11a1 1 0 0 0-.28-.71l-8-8A1 1 0 0 0 17 2H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V11Zm-8-5.59L22.59 10H19a1 1 0 0 1-1-1ZM23 28H9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7v5a3 3 0 0 0 3 3h5v15a1 1 0 0 1-1 1Z" />
    <path d="M11 16h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2ZM21 18H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2ZM21 22H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z" />
  </FillSvg>
);

{
  /* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g data-name="paper, texture, background, cardboard, pattern, page, blank, white, letter, canvas"><path d="M26 11a1 1 0 0 0-.28-.71l-8-8A1 1 0 0 0 17 2H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V11Zm-8-5.59L22.59 10H19a1 1 0 0 1-1-1ZM23 28H9a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7v5a3 3 0 0 0 3 3h5v15a1 1 0 0 1-1 1Z"/><path d="M11 16h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2ZM21 18H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2ZM21 22H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2Z"/></g></svg> */
}

export const PaletteIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M7.522 12.828c0 0.005 0 0.011 0 0.016 0 1.18 0.957 2.137 2.137 2.137 1.163 0 2.109-0.929 2.136-2.085 0.001-0.073 0.001-0.079 0.001-0.084 0-1.18-0.957-2.137-2.137-2.137-1.163 0-2.109 0.929-2.136 2.085zM7.287 18.585c0 0.003 0 0.008 0 0.012 0 1.18 0.957 2.137 2.137 2.137 1.168 0 2.117-0.937 2.136-2.1 0-0.052 0-0.056 0-0.060 0-1.18-0.957-2.137-2.137-2.137-1.168 0-2.117 0.937-2.136 2.1zM11.551 22.696c0 1.18 0.957 2.137 2.137 2.137s2.137-0.957 2.137-2.137c0-1.18-0.957-2.137-2.137-2.137s-2.137 0.957-2.137 2.137zM17.282 21.86c0 1.18 0.957 2.137 2.137 2.137s2.137-0.957 2.137-2.137c0-1.18-0.957-2.137-2.137-2.137s-2.137 0.957-2.137 2.137zM15.776 28.73c-7.007 0-12.708-5.701-12.708-12.708s5.7-12.707 12.707-12.708c0.040 0 0.079 0.003 0.117 0.008 2.944 0.036 4.399 1.432 4.541 2.816 0.111 1.076-0.609 2.335-2.467 2.721-0.866 0.18-1.351 0.597-1.298 1.116 0.049 0.475 0.532 0.981 1.332 0.981 0.353 0 0.735-0.097 1.133-0.288 0.803-0.386 1.724-0.59 2.662-0.59 2.028 0 3.959 0.931 5.165 2.489 0.968 1.25 1.932 3.472 1.030 6.955-1.564 5.431-6.584 9.208-12.215 9.208zM15.682 5.095c-5.982 0.051-10.833 4.933-10.833 10.927 0 6.025 4.902 10.927 10.927 10.927 4.841 0 9.159-3.247 10.498-7.897 0.564-2.181 0.317-4.055-0.721-5.396-0.872-1.126-2.277-1.798-3.757-1.798-0.673 0-1.327 0.143-1.891 0.414-0.641 0.308-1.282 0.464-1.904 0.464-1.618 0-2.952-1.109-3.103-2.579-0.115-1.119 0.525-2.588 2.707-3.041 0.668-0.139 1.093-0.458 1.058-0.796-0.052-0.506-0.977-1.218-2.872-1.218-0.036 0-0.072-0.002-0.108-0.006z" />
  </FillSvg>
);

export const PenIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M27.857 7.952l-4.038-4.038c-0.373-0.372-0.976-0.372-1.349 0l-15.409 15.409c-0.093 0.092-0.165 0.203-0.213 0.324l-2.924 7.399c-0.145 0.366-0.049 0.784 0.24 1.052 0.18 0.166 0.412 0.253 0.647 0.253 0.143 0 0.287-0.032 0.421-0.098l7.081-3.481c0.094-0.047 0.18-0.107 0.254-0.181l15.291-15.291c0.179-0.179 0.28-0.422 0.28-0.675-0.002-0.253-0.102-0.495-0.281-0.674zM23.145 5.937l2.689 2.689-0.68 0.68-2.768-2.61 0.759-0.759zM11.33 23.131l-3.071 1.51c-0.12-0.155-0.267-0.326-0.45-0.509-0.181-0.181-0.352-0.322-0.508-0.437l1.25-3.162 12.486-12.486 2.768 2.61-12.475 12.475z" />
  </FillSvg>
);

export const PhoneIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M22 17v3a2 2 0 01-2 2 20 20 0 01-15-9L2 4a2 2 0 012-2h3a2 2 0 012 2l1 3a2 2 0 01-1 2l-1 1 6 6 1-1a2 2 0 012-1l3 1a2 2 0 012 2z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const PinterestSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M16.04,29.17c-7.3-0.02-13.21-5.82-13.2-13.18C2.85,8.65,8.56,3.28,15.09,2.86c3.75-0.24,7.05,0.91,9.81,3.45 c2.82,2.59,4.27,5.87,4.26,9.7C29.14,23.32,23.3,29.11,16.04,29.17z M14.93,18.67c0.54,0.62,0.96,0.91,1.59,1.06 c1.34,0.32,2.56,0,3.65-0.78c0.98-0.7,1.62-1.66,2.03-2.78c0.43-1.19,0.66-2.42,0.51-3.67c-0.27-2.22-1.52-3.75-3.55-4.64 C17.82,7.27,16.42,7.18,15,7.43c-2.55,0.45-4.43,1.78-5.36,4.26c-0.51,1.36-0.46,2.73,0.12,4.07c0.31,0.72,0.82,1.24,1.55,1.56 c0.29,0.13,0.48,0.03,0.56-0.28c0.04-0.14,0.08-0.28,0.13-0.42c0.12-0.39,0.13-0.77-0.2-1.07c-0.05-0.06-0.07-0.09-0.1-0.15 c-0.39-0.65-0.46-1.35-0.4-2.1c0.15-1.97,1.7-3.75,3.63-4.14C15.63,9.02,16.33,9,17.04,9.1c1.03,0.15,1.91,0.57,2.54,1.43 c0.57,0.78,0.73,1.66,0.69,2.62c-0.05,1.05-0.22,2.06-0.66,3.02c-0.3,0.64-0.7,1.21-1.31,1.6c-0.47,0.3-0.99,0.4-1.54,0.29 c-0.79-0.16-1.4-0.93-1.16-1.86c0.24-0.93,0.53-1.84,0.77-2.77c0.13-0.51,0.2-1.04-0.06-1.54c-0.16-0.31-0.38-0.55-0.74-0.64 c-0.71-0.19-1.35,0.03-1.8,0.65c-0.65,0.89-0.68,1.89-0.45,2.93c0.06,0.27,0.2,0.51,0.12,0.83c-0.43,1.69-0.83,3.39-1.22,5.09 c-0.28,1.22-0.21,2.46-0.04,3.69c0.01,0.07,0.07,0.13,0.1,0.2c0.07-0.04,0.16-0.06,0.21-0.12c0.93-1.15,1.63-2.41,1.94-3.88 C14.57,19.98,14.76,19.34,14.93,18.67L14.93,18.67z" />
  </FillSvg>
);

export const PinterestIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M15.867 31.333c-8.533 0-15.6-6.933-15.6-15.6 0-8.533 6.933-15.6 15.6-15.6 8.533 0 15.6 6.933 15.6 15.6-0.133 8.667-7.067 15.6-15.6 15.6zM15.867 2.4c-7.333 0-13.467 6-13.467 13.467 0 7.333 6 13.467 13.467 13.467s13.467-6 13.467-13.467c-0.133-7.467-6.133-13.467-13.467-13.467zM11.333 18l0.267-0.933c0 0 0.133-0.267-0.133-0.533s-0.8-0.933-0.8-2.267c0-2.533 2-5.333 5.467-5.333s4.667 2.267 4.667 4.267c0 2.4-1.067 6-3.467 6-1.467 0-1.867-1.2-1.867-1.733 0-0.133 0-0.4 0-0.533s0.667-2 0.8-2.667c0.4-1.6 0-2.8-1.333-2.8-2 0-2.667 2.8-1.733 4.667l-1.333 5.867c0 0-0.133 0.933-0.267 1.467 0 0.933 0 2.133 0.133 2.533 0 0.267 0 0.4 0.133 0.4s0.267-0.133 0.533-0.4c0.267-0.267 0.933-1.333 1.2-2 0.267-0.533 0.267-0.667 0.533-1.733s0.667-2.533 0.667-2.533 0.8 1.333 2.8 1.333c2.933 0 5.867-2.667 5.867-7.6 0-4-3.333-6.4-7.2-6.4-4.8 0-7.867 3.467-7.867 6.8s1.733 4 2.133 4.267c0.533 0.267 0.8 0.133 0.8-0.133z" />
  </FillSvg>
);

export const PlusIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M25.827 14.636h-8.405v-8.405c0-0.767-0.621-1.388-1.388-1.388s-1.388 0.621-1.388 1.388v8.405h-8.405c-0.767 0-1.388 0.621-1.388 1.388s0.621 1.388 1.388 1.388h8.405v8.405c0 0.767 0.621 1.388 1.388 1.388s1.388-0.621 1.388-1.388v-8.405h8.405c0.767 0 1.388-0.621 1.388-1.388s-0.621-1.388-1.388-1.388z" />
  </FillSvg>
);

export const PrintIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M10.4,7.3V4.6c0-0.5,0.4-1,1-1h9.4c0.5,0,1,0.4,1,1v2.7c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3 c-0.5,0-1-0.4-1-1V5.5h-7.5v1.8c0,0.5-0.4,1-1,1C10.8,8.3,10.4,7.8,10.4,7.3z M20.7,19.4c-0.5,0-1,0.4-1,1v6.1h-7.5v-6.1 c0-0.3-0.2-0.7-0.5-0.8c-0.3-0.2-0.7-0.2-1,0c-0.3,0.2-0.5,0.5-0.5,0.8v7c0,0.5,0.4,1,1,1h9.4c0.5,0,1-0.4,1-1v-7 C21.6,19.9,21.2,19.4,20.7,19.4z M20.7,15.7h-9.4c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h9.4c0.5,0,1-0.4,1-1 C21.6,16.2,21.2,15.7,20.7,15.7z M24.1,14.1c0-0.3-0.1-0.5-0.3-0.7c-0.4-0.4-1-0.4-1.4,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.5,0.4,1,1,1 C23.7,15,24.1,14.6,24.1,14.1z M25.1,9.5H6.9c-1.5,0-2.8,1.2-2.8,2.8v8.4c0,1.5,1.2,2.8,2.6,2.8h1.7c0.5,0,1-0.4,1-1 c0-0.5-0.4-1-1-1H6.8c-0.4,0-0.7-0.4-0.7-0.9v-8.4c0-0.5,0.4-0.9,0.9-0.9h18.1c0.5,0,0.9,0.4,0.9,0.9v8.4c0,0.5-0.3,0.9-0.7,0.9 h-1.7c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h1.7c1.5,0,2.6-1.2,2.6-2.8v-8.4C27.8,10.7,26.6,9.5,25.1,9.5z" />
  </FillSvg>
);

export const QuoteLeftIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M13.732 26.626c-8.82-3.78-12.684-8.484-12.684-14.7 0-3.864 2.268-6.552 5.88-6.552 2.856 0 4.872 2.352 4.872 5.124 0 2.436-1.764 4.284-4.032 4.284-0.924 0-1.764-0.42-2.436-0.84l-0.504 0.252c0.504 3.78 3.864 7.392 10.248 10.248l-1.344 2.184zM29.608 26.626c-8.82-3.78-12.684-8.484-12.684-14.7 0-3.864 2.268-6.552 5.88-6.552 2.856 0 4.872 2.352 4.872 5.124 0 2.436-1.764 4.284-4.032 4.284-0.924 0-1.764-0.42-2.436-0.84l-0.504 0.252c0.504 3.78 3.864 7.392 10.248 10.248l-1.344 2.184z" />
  </FillSvg>
);

export const QuoteRightIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M18.268 26.626c8.82-3.78 12.684-8.484 12.684-14.7 0-3.864-2.268-6.552-5.88-6.552-2.856 0-4.872 2.352-4.872 5.124 0 2.436 1.764 4.284 4.032 4.284 0.924 0 1.764-0.42 2.436-0.84l0.504 0.252c-0.504 3.78-3.864 7.392-10.248 10.248l1.344 2.184zM2.392 26.626c8.82-3.78 12.684-8.484 12.684-14.7 0-3.864-2.268-6.552-5.88-6.552-2.856 0-4.872 2.352-4.872 5.124 0 2.436 1.764 4.284 4.032 4.284 0.924 0 1.764-0.42 2.436-0.84l0.504 0.252c-0.504 3.78-3.864 7.392-10.248 10.248l1.344 2.184z" />
  </FillSvg>
);

export const RedoSlashIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M23.979 12.39c-0.573 0.184-0.887 0.798-0.703 1.371 0.241 0.748 0.363 1.53 0.363 2.324 0 4.18-3.401 7.581-7.581 7.581-0.602 0-1.089 0.488-1.089 1.089s0.488 1.089 1.089 1.089c5.381 0 9.76-4.378 9.76-9.76 0-1.021-0.157-2.028-0.468-2.991-0.184-0.573-0.799-0.887-1.371-0.703zM6.544 16.768c0.026 0.033 0.052 0.066 0.082 0.096 0.022 0.021 0.047 0.039 0.070 0.058 0.031 0.026 0.061 0.052 0.094 0.074 0.025 0.016 0.052 0.028 0.078 0.042 0.037 0.020 0.072 0.041 0.11 0.056 0.027 0.011 0.056 0.017 0.084 0.026 0.040 0.012 0.080 0.026 0.121 0.034 0.004 0.001 0.008 0.003 0.013 0.004 0.063 0.011 0.126 0.017 0.189 0.017 0.066 0 0.131-0.008 0.196-0.020 0.022-0.004 0.043-0.010 0.064-0.015 0.042-0.011 0.084-0.023 0.124-0.039 0.022-0.008 0.044-0.017 0.065-0.026 0.042-0.019 0.083-0.042 0.123-0.067 0.015-0.009 0.030-0.017 0.045-0.026 0.003-0.002 0.006-0.003 0.008-0.005l3.808-2.67c0.493-0.345 0.612-1.025 0.267-1.517s-1.025-0.612-1.517-0.267l-1.716 1.203c0.994-3.029 3.847-5.223 7.204-5.223 1.167 0 2.287 0.258 3.328 0.767 0.541 0.265 1.193 0.040 1.457-0.5s0.041-1.193-0.499-1.457c-1.341-0.656-2.782-0.989-4.285-0.989-4.392 0-8.115 2.916-9.335 6.914l-1.207-1.722c-0.345-0.492-1.025-0.612-1.517-0.267s-0.612 1.025-0.267 1.517l2.764 3.943c0.015 0.020 0.034 0.037 0.050 0.057zM28.068 4.836c-0.425-0.425-1.115-0.425-1.54 0l-20.945 20.945c-0.425 0.425-0.425 1.115 0 1.54 0.213 0.213 0.492 0.319 0.77 0.319s0.558-0.106 0.77-0.319l20.945-20.945c0.425-0.426 0.425-1.115 0-1.541z" />
  </FillSvg>
);

export const SaveIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M20.903 7.892v4.417h-10.293v-4.417c0-0.526-0.426-0.952-0.952-0.952s-0.952 0.426-0.952 0.952v5.369c0 0.526 0.426 0.952 0.952 0.952h12.197c0.526 0 0.952-0.426 0.952-0.952v-5.369c0-0.526-0.426-0.952-0.952-0.952s-0.952 0.426-0.952 0.952zM17.51 11.23c0.526 0 0.952-0.426 0.952-0.952v-2.386c0-0.526-0.426-0.952-0.952-0.952s-0.952 0.426-0.952 0.952v2.386c0 0.526 0.426 0.952 0.952 0.952zM28.114 8.743l-4.85-4.85c-0.178-0.178-0.42-0.279-0.673-0.279l-18.083-0.001c-0.252 0-0.495 0.1-0.673 0.279s-0.279 0.421-0.279 0.673v22.933c0 0.526 0.426 0.952 0.952 0.952h22.933c0.526 0 0.952-0.426 0.952-0.952v-18.082c0.001-0.253-0.1-0.495-0.278-0.673zM22.752 26.546h-13.555v-8.839h13.555v8.839zM26.489 26.546h-2.151v-9.633c0-0.438-0.355-0.793-0.793-0.793h-15.141c-0.438 0-0.793 0.355-0.793 0.793v9.633h-2.151v-21.029l16.737 0.001 4.293 4.292v16.736z" />
  </FillSvg>
);

export const SearchIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M15.8 14.6l-2.9-2.9c1-1.2 1.6-2.8 1.6-4.5 0-4-3.2-7.2-7.2-7.2C3.2 0 0 3.2 0 7.2s3.2 7.2 7.2 7.2c1.7 0 3.3-.6 4.5-1.6l2.9 2.9c.2.2.4.2.6.2.2 0 .4-.1.6-.2.3-.2.3-.8 0-1.1zM1.6 7.2c0-3.1 2.5-5.6 5.6-5.6 3.1 0 5.6 2.5 5.6 5.6 0 1.5-.6 2.9-1.6 3.9s-2.4 1.6-3.9 1.6c-3.2.1-5.7-2.4-5.7-5.5z" />
  </FillSvg>
);

export const SearchSlashIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M28.1 25.7L23 20.6c-.4-.4-1-.6-1.6-.5l-1.8-1.8c.2-.2.3-.4.5-.6.6-.9-.5-2.1-1.5-1.5-.1.1-.2.1-.3.2-1.1 1.4-.8 1.1-2.3 2.2l-.3.3c-.6 1 .5 2 1.5 1.4.3-.2.6-.4.8-.6l1.8 1.8c-.1.6.1 1.1.5 1.6l5.1 5.1c.4.4.8.5 1.3.5s.9-.2 1.3-.5c.8-.7.8-1.8.1-2.5zM6.9 20.1c.5.2 1.1.1 1.4-.2.5-.5.4-1.2-.2-1.6-1.9-1.4-3-3.5-2.9-5.7 0-3.9 3.2-7.1 7.1-7.1 2.3 0 4.5 1.1 5.8 3 .4.5 1.1.6 1.6.2.4-.4.5-.9.2-1.4-1.5-2.2-4.5-4.2-8.3-3.9-4.3.4-7.8 3.7-8.4 8-.5 3.9 1.5 7 3.7 8.7zM26.8 5.1c-.3-.3-.9-.3-1.2 0L4.9 25.7c-.3.3-.3.9 0 1.2.2.2.4.3.6.3.3 0 .5 0 .6-.2L26.8 6.3c.3-.3.3-.9 0-1.2z" />
  </FillSvg>
);

export const ShareIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M23,20c-1.1,0-2.1,0.5-2.9,1.2l-7.3-4.2c0.1-0.3,0.2-0.7,0.2-1.1c0-0.4-0.1-0.7-0.2-1.1l7.3-4.2 c0.7,0.7,1.7,1.2,2.9,1.2c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4c0,0.4,0.1,0.7,0.2,1.1l-7.3,4.2C11.1,12.5,10.1,12,9,12 c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c1.1,0,2.1-0.5,2.9-1.2l7.3,4.2C19.1,23.3,19,23.6,19,24c0,2.2,1.8,4,4,4s4-1.8,4-4S25.2,20,23,20 z M23,6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S21.9,6,23,6z M9,18c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2 C11,17.1,10.1,18,9,18z M23,26c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S24.1,26,23,26z" />
  </FillSvg>
);

export const SlidersIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const StoreIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M15.9 4.9l-1.4-3.6-.7.3.7-.3c-.1-.3-.4-.5-.7-.5H2.2c-.3 0-.6.2-.7.5L.1 4.9l.7.3-.7-.3c-.1.1-.1.2-.1.3v9.2c0 .4.4.8.8.8H8c.4 0 .8-.4.8-.8v-3.5H10v3.5c0 .4.4.8.8.8h4.4c.4 0 .8-.4.8-.8V5.2c0-.1 0-.2-.1-.3zm-1.5 8.7h-2.8v-3.5c0-.4-.4-.8-.8-.8H8c-.4 0-.8.4-.8.8v3.5H1.6V6h12.8v7.6zM2.8 2.4h10.5l.8 2H2l.8-2z" />
  </FillSvg>
);

export const TargetIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M12 22c5.5228 0 10-4.4772 10-10 0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12c0 5.5228 4.47715 10 10 10Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6-3.31371 0-6 2.68629-6 6 0 3.3137 2.68629 6 6 6Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ThumbDownIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 22 22" className={className}>
    <path d="M22 2.9C21.8 1.2 20.4 0 18.7 0h-14C3.2 0 2 1.1 1.7 2.5l-1.4 9c-.1.9.1 1.8.7 2.4.6.7 1.5 1 2.3 1H8v3c0 2.2 1.8 4 4 4 .4 0 .8-.2.9-.6l3.7-8.4h2c1.7 0 3.1-1.2 3.3-2.9V3c.1 0 .1-.1.1-.1zm-7 8.9l-3.6 8.1c-.8-.3-1.4-1-1.4-1.9v-4c0-.6-.4-1-1-1H3.3c-.3 0-.6-.1-.8-.3-.2-.2-.3-.5-.2-.8l1.4-9c.1-.5.5-.9 1-.9H15v9.8zm5-1.9c-.1.6-.7 1.1-1.3 1.1H17V2h1.7c.6-.1 1.2.4 1.3 1.1v6.8z" />
  </FillSvg>
);

export const ThumbUpIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 22 22" className={className}>
    <path d="M20.9 8c-.6-.7-1.4-1-2.3-1H14V4c0-2.2-1.8-4-4-4-.4 0-.8.2-.9.6L5.4 9H3c-1.7 0-3 1.3-3 3v7c0 1.7 1.3 3 3 3h14.3c1.5 0 2.7-1.1 3-2.5l1.4-9c.1-.9-.2-1.8-.8-2.5zM5 20H3c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h2v9zm13.3-.8c-.1.5-.5.8-1 .8H7v-9.8l3.6-8.1c.8.3 1.4 1 1.4 1.9v4c0 .6.4 1 1 1h5.7c.3 0 .6.1.8.3.2.2.3.5.2.8l-1.4 9.1z" />
  </FillSvg>
);

export const TimesCircleIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0zm13-4v2l-3 2 3 2a1 1 0 01-2 2l-2-3-2 3a1 1 0 01-2-2l3-2-3-2a1 1 0 012-2l2 3 2-3h2z"
    />
  </FillSvg>
);

export const TimesIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path d="M18 6 6 18M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </StrokeSvg>
);

export const ToolsIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M22.408 17.198c-0.373-0.373-0.976-0.373-1.349 0s-0.373 0.976 0 1.349l0.377 0.377-0.761 0.76c-0.311 0.31-0.311 0.814 0 1.124 0.155 0.155 0.359 0.233 0.562 0.233s0.407-0.078 0.562-0.233l0.761-0.76 1.202 1.202-0.76 0.761c-0.311 0.311-0.311 0.814 0 1.124 0.155 0.155 0.359 0.233 0.562 0.233s0.407-0.078 0.562-0.233l0.76-0.76 1.016 1.016-2.69 2.69-4.844-4.844c-0.373-0.373-0.976-0.373-1.349 0s-0.373 0.977 0 1.349l5.519 5.519c0.186 0.186 0.431 0.28 0.675 0.28s0.488-0.093 0.675-0.28l4.039-4.039c0.373-0.372 0.373-0.976 0-1.349l-5.52-5.519zM25.833 11.421c0.001-0.001 0.001-0.001 0.001-0.002l2.092-2.092c0.373-0.372 0.373-0.977 0-1.349l-4.039-4.039c-0.358-0.358-0.991-0.358-1.349 0l-2.134 2.134c0 0-0.001 0-0.001 0.001s0 0.001-0.001 0.001l-13.28 13.28c-0.093 0.092-0.165 0.203-0.213 0.324l-2.925 7.402c-0.145 0.367-0.049 0.785 0.24 1.052 0.18 0.166 0.412 0.253 0.647 0.253 0.143 0 0.287-0.032 0.421-0.098l7.083-3.482c0.094-0.047 0.18-0.107 0.254-0.182l13.201-13.201c0 0 0-0.001 0.001-0.001zM23.213 5.962l2.69 2.69-0.754 0.754-2.71-2.67 0.775-0.775zM11.393 23.162l-3.073 1.51c-0.12-0.155-0.267-0.326-0.45-0.509-0.181-0.181-0.351-0.322-0.508-0.437l1.25-3.163 12.476-12.477 2.71 2.67-12.406 12.406zM9.494 15.062c0.186 0.186 0.431 0.28 0.675 0.28s0.489-0.093 0.675-0.279c0.373-0.373 0.373-0.977 0-1.349l-4.844-4.844 2.69-2.69 1.016 1.016-0.76 0.76c-0.311 0.311-0.311 0.814 0 1.124 0.155 0.155 0.359 0.233 0.562 0.233s0.407-0.078 0.562-0.233l0.761-0.76 1.202 1.202-0.76 0.761c-0.31 0.31-0.31 0.814 0 1.124 0.155 0.155 0.359 0.233 0.562 0.233s0.407-0.078 0.562-0.233l0.76-0.76 0.377 0.377c0.372 0.373 0.977 0.373 1.349 0s0.373-0.977 0-1.349l-5.519-5.519c-0.372-0.373-0.977-0.373-1.349 0l-4.039 4.039c-0.373 0.372-0.373 0.977 0 1.349l5.518 5.518z" />
  </FillSvg>
);

export const EditIcon = ({ className, strokeWidth }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 64 64" className={className}>
    <path
      d="M23 62c0 .8.6 1.5 1.5 1.5h20c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5h-20C23.6 60.5 23 61.2 23 62zM10.9 55.5l-.4 6.5c-.1.5.3 1.1.8 1.4.3.2.5.2.8.2.3 0 .6-.1.9-.3l5.4-3.5c2.8-1.8 5.1-4.3 6.8-7.2l15.2-26.2c.4-.7.2-1.6-.5-2s-1.7-.1-2 .5L22.4 51c-1.5 2.5-3.5 4.6-5.9 6.2l-2.9 1.9.2-3.5c.1-2.8 1-5.7 2.4-8.2l15.1-26.2c.4-.7.1-1.6-.5-2-.7-.4-1.6-.1-2 .5L13.8 46C12.1 48.9 11.1 52.2 10.9 55.5zM43.3 20.9l1.8-3.3c.8-1.5 1.1-3.3.7-4.9-.5-1.7-1.5-3.1-3-3.9s-3.3-1.1-5-.6c-1.7.4-3.1 1.6-4 3.1L32 14.4c-.4.7-.1 1.6.5 2l8.6 5c.3.1.5.2.8.2.2 0 .3 0 .4 0C42.8 21.5 43 21.2 43.3 20.9zM52 60.5A1.5 1.5 0 1052 63.5 1.5 1.5 0 1052 60.5z"
      strokeWidth={strokeWidth || 2}
    />
  </FillSvg>
);

export const TrashcanIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 25" className={className}>
    <path
      d="M3 7h18M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V7h14zM10 12v6M14 12v6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const TruckIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M1 3h15v13H1V3ZM16 8h4l3 3v5h-7V8ZM5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const TwitterSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M29.95 7.402c-1.027 0.451-2.129 0.759-3.286 0.895 1.183-0.704 2.089-1.817 2.517-3.147-1.107 0.652-2.333 1.125-3.637 1.381-1.044-1.107-2.531-1.796-4.178-1.796-3.163 0-5.724 2.548-5.724 5.688 0 0.446 0.051 0.879 0.148 1.297-4.757-0.238-8.973-2.504-11.797-5.944-0.493 0.84-0.776 1.817-0.776 2.86 0 1.973 1.010 3.714 2.547 4.734-0.938-0.030-1.821-0.286-2.592-0.713-0.001 0.023-0.001 0.047-0.001 0.072 0 2.755 1.973 5.054 4.591 5.577-0.48 0.13-0.987 0.201-1.507 0.201-0.37 0-0.727-0.035-1.077-0.102 0.728 2.259 2.842 3.904 5.347 3.949-1.96 1.526-4.427 2.435-7.108 2.435-0.462 0-0.917-0.026-1.365-0.079 2.532 1.614 5.543 2.557 8.775 2.557 10.528 0 16.285-8.668 16.285-16.183 0-0.247-0.004-0.491-0.018-0.736 1.118-0.802 2.088-1.804 2.856-2.945z" />
  </FillSvg>
);

export const UserSolidIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M19.908 18.671c-0.045-0.030-0.17-0.289 0.007-0.938 1.823-1.999 2.947-4.858 2.947-7.531 0-4.263-2.815-7.239-6.845-7.239-4.022 0-6.831 2.977-6.831 7.239 0 2.71 1.136 5.591 2.976 7.58 0.175 0.597-0.050 0.81-0.189 0.876-1.828 0.666-7.794 3.101-7.794 6.479v2.852c0 0.485 0.34 0.903 0.814 1.002 3.67 0.767 7.358 1.15 11.042 1.15s7.361-0.384 11.006-1.151c0.474-0.1 0.813-0.517 0.813-1.002v-2.852c0-3.637-6.665-6.043-7.945-6.465z" />
  </FillSvg>
);

export const UserIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 16 16" className={className}>
    <path d="M15.2 13.5v1.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.6c0-.6-.2-1.2-.7-1.6-.4-.4-1-.7-1.6-.7H4.8c-.6 0-1.2.2-1.6.7-.4.4-.7 1-.7 1.6v1.6c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-1.6c0-1.1.4-2.1 1.2-2.9.8-.8 1.8-1.2 2.9-1.2h6.3c1.1 0 2.1.4 2.9 1.2.8.8 1.2 1.8 1.2 2.9zM4 4c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4c-2.2.1-4-1.7-4-4zm1.7 0c0 1.3 1 2.3 2.3 2.3s2.3-1 2.3-2.3-1-2.2-2.3-2.2-2.3 1-2.3 2.2z" />
  </FillSvg>
);

export const WalletIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path
      d="M8 9h10c2 0 2 1 2 2v7c0 2 0 2-2 2H6c-1 0-2 0-2-2V9c0-1 0-2 2-3l10-2 2 1v1"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path d="M17 15h0" strokeWidth="3" strokeLinecap="round" />
  </StrokeSvg>
);

export const ZoomInIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M0.929 27.969l6.4-6.4c0.516-0.516 1.239-0.723 1.961-0.619l2.271-2.271c-1.548-1.961-2.477-4.439-2.477-7.123 0-6.297 5.161-11.458 11.458-11.458s11.458 5.161 11.458 11.458c0 6.297-5.161 11.458-11.458 11.458-2.684 0-5.161-0.929-7.123-2.477l-2.271 2.271c0.103 0.723-0.103 1.445-0.619 1.961l-6.4 6.4c-0.413 0.413-1.032 0.619-1.548 0.619s-1.135-0.206-1.548-0.619c-1.032-0.929-1.032-2.374-0.103-3.2v0zM29.213 11.66c0-4.852-3.923-8.774-8.774-8.774s-8.774 3.923-8.774 8.774c0 4.852 3.923 8.774 8.774 8.774 4.748 0 8.774-3.923 8.774-8.774zM25.29 12.176v-1.342h-4.232v-4.232h-1.342v4.232h-4.232v1.342h4.232v4.335h1.342v-4.335h4.232z" />
  </FillSvg>
);

export const ZoomOutIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M0.929 27.969l6.4-6.4c0.516-0.516 1.239-0.723 1.961-0.619l2.271-2.271c-1.548-1.961-2.477-4.439-2.477-7.123 0-6.297 5.161-11.458 11.458-11.458s11.458 5.161 11.458 11.458c0 6.297-5.161 11.458-11.458 11.458-2.684 0-5.161-0.929-7.123-2.477l-2.271 2.271c0.103 0.723-0.103 1.445-0.619 1.961l-6.4 6.4c-0.413 0.413-1.032 0.619-1.548 0.619s-1.135-0.206-1.548-0.619c-1.032-0.929-1.032-2.374-0.103-3.2v0zM29.213 11.66c0-4.852-3.923-8.774-8.774-8.774s-8.774 3.923-8.774 8.774c0 4.852 3.923 8.774 8.774 8.774 4.748 0 8.774-3.923 8.774-8.774zM15.484 10.937v1.342h9.806v-1.342h-9.806z" />
  </FillSvg>
);

export const FullscreenIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <path d="M32 29.333h-32v-26.667h32v26.667zM2.667 26.667h26.667v-21.333h-26.667v21.333z" />
    <g id="tr">
      <path d="M26.667 16h-2.667v-5.333h-5.333v-2.667h8z" />
    </g>
    <g id="bl">
      <path d="M13.333 24h-8v-8h2.667v5.333h5.333z" />
    </g>
  </FillSvg>
);

export const SortIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 320 512" className={className}>
    <path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z" />
  </FillSvg>
);

export const SortDownIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 320 512" className={className}>
    <path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z" />
  </FillSvg>
);

export const SortUpIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 320 512" className={className}>
    <path d="M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z" />
  </FillSvg>
);

export const SortAltIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 16 16" className={className}>
    <path d="M12 8H4M14 4H2M10 12H6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </StrokeSvg>
);

// Stock icons
export const StockCheckIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path d="M18.7 7.3c-.4-.4-1-.4-1.4 0L10 14.6l-3.3-3.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l4 4c.2.2.4.3.7.3s.5-.1.7-.3l8-8c.4-.4.4-1 0-1.4z" />
  </FillSvg>
);

export const StockCrossIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path d="M17.1 6.9c-.4-.4-1-.4-1.4 0l-3.6 3.6-3.6-3.6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.6 3.6-3.6 3.6c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.6-3.6 3.6 3.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-3.6-3.6 3.6-3.6c.4-.4.4-1 0-1.4z" />
  </FillSvg>
);

export const StockDeliveryIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zm4.9-5.6c-.1.3-.5.6-.9.6-.1 0-.2 0-.3-.1l-4-1.4c-.4-.1-.7-.5-.7-.9V7c0-.6.4-1 1-1s1 .4 1 1v4.9l3.3 1.2c.5.2.8.8.6 1.3z" />
  </FillSvg>
);

export const StockFastDeliveryIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path d="M15.5 3.5C10.8 3.5 7 7.3 7 12s3.8 8.5 8.5 8.5S24 16.7 24 12s-3.8-8.5-8.5-8.5zm0 15C11.9 18.5 9 15.6 9 12s2.9-6.5 6.5-6.5S22 8.4 22 12s-2.9 6.5-6.5 6.5zm3.4-3.1c-.2.4-.5.6-.9.6-.1 0-.3 0-.4-.1l-3-1.4c-.4-.2-.6-.5-.6-.9V8c0-.6.4-1 1-1s1 .4 1 1v4.9l2.4 1.2c.5.2.7.8.5 1.3zM5.4 15c.2.7.5 1.4.8 2H1c-.6 0-1-.4-1-1s.4-1 1-1h4.4zM3 7h3.2c-.3.6-.6 1.3-.8 2H3c-.6 0-1-.4-1-1s.4-1 1-1zm-2 5c0-.6.4-1 1-1h3v1c0 .3 0 .7.1 1H2c-.6 0-1-.4-1-1z" />
  </FillSvg>
);

export const LaptopIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <path d="M3 5V4.5C2.72386 4.5 2.5 4.72386 2.5 5H3ZM21 5H21.5C21.5 4.72386 21.2761 4.5 21 4.5V5ZM23 18.5H1V19.5H23V18.5ZM1 18.5H9V17.5H1V18.5ZM15 18.5H23V17.5H15V18.5ZM3.5 16V5H2.5V16H3.5ZM3 5.5H21V4.5H3V5.5ZM20.5 5V16H21.5V5H20.5Z" />
  </FillSvg>
);

/* Laundry icons */

export const BleachingAllowedIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M14.2542 5.27637L5.60694 24.0227C5.42865 24.4236 5.33432 24.8782 5.33332 25.3412C5.33232 25.8042 5.4247 26.2594 5.60125 26.6617C5.77781 27.0639 6.03239 27.3991 6.33967 27.6339C6.64695 27.8687 6.99622 27.9949 7.35273 28H24.6472C25.0037 27.9949 25.353 27.8687 25.6603 27.6339C25.9676 27.3991 26.2222 27.0639 26.3987 26.6617C26.5753 26.2594 26.6676 25.8042 26.6666 25.3412C26.6656 24.8782 26.5713 24.4236 26.393 24.0227L17.7458 5.27637C17.5638 4.88674 17.3075 4.5646 17.0017 4.34102C16.6959 4.11745 16.3509 4 16 4C15.6491 4 15.304 4.11745 14.9982 4.34102C14.6925 4.5646 14.4362 4.88674 14.2542 5.27637Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const BleachingDoNotBleachIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M29.3333 9.33333L2.66663 22.6667M2.66663 9.33333L29.3333 22.6667M14.4724 5.27637L6.90605 24.0227C6.75005 24.4236 6.66751 24.8782 6.66663 25.3412C6.66576 25.8042 6.74659 26.2594 6.90107 26.6617C7.05556 27.0639 7.27832 27.3991 7.54719 27.6339C7.81606 27.8687 8.12167 27.9949 8.43361 28H23.5663C23.8783 27.9949 24.1839 27.8687 24.4527 27.6339C24.7216 27.3991 24.9444 27.0639 25.0988 26.6617C25.2533 26.2594 25.3342 25.8042 25.3333 25.3412C25.3324 24.8782 25.2499 24.4236 25.0939 24.0227L17.5275 5.27637C17.3683 4.88674 17.144 4.5646 16.8765 4.34102C16.6089 4.11745 16.307 4 16 4C15.6929 4 15.391 4.11745 15.1234 4.34102C14.8559 4.5646 14.6316 4.88674 14.4724 5.27637Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const BleachingOnlyNonChlorineIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M19.3333 9.33333L10.6666 28M22.6666 16L17.3333 28M14.2542 5.27637L5.60694 24.0227C5.42865 24.4236 5.33432 24.8782 5.33332 25.3412C5.33232 25.8042 5.4247 26.2594 5.60125 26.6617C5.77781 27.0639 6.03239 27.3991 6.33967 27.6339C6.64695 27.8687 6.99622 27.9949 7.35273 28H24.6472C25.0037 27.9949 25.353 27.8687 25.6603 27.6339C25.9676 27.3991 26.2222 27.0639 26.3987 26.6617C26.5753 26.2594 26.6676 25.8042 26.6666 25.3412C26.6656 24.8782 26.5713 24.4236 26.393 24.0227L17.7458 5.27637C17.5638 4.88674 17.3075 4.5646 17.0017 4.34102C16.6959 4.11745 16.3509 4 16 4C15.6491 4 15.304 4.11745 14.9982 4.34102C14.6925 4.5646 14.4362 4.88674 14.2542 5.27637Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const DryingDoNotTumbleDryIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M1 1H31M1 1V31M1 1L31 31M31 1V31M31 1L1 31M31 31H1M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const DryingDripDryIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M16 7V25M24 7V25M8 7V25M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
  </StrokeSvg>
);

export const DryingDripDryInShadeIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M1 9L9 1M1 17L17 1M16 7V25M24 7V25M8 7V25M1 1H31V31H1V1Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </StrokeSvg>
);

export const DryingDryFlatIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M6 16H26M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
  </StrokeSvg>
);

export const DryingDryFlatInShadeIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M1 9L9 1M1 17L17 1M6 16H26M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
  </StrokeSvg>
);

export const DryingTumbleDryingAllowedIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
    <path
      d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </StrokeSvg>
);

export const DryingTumbleDryingLowIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
    <path
      d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M16 16H16.0125" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </StrokeSvg>
);

export const DryingTumbleDryingNormalIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M1 1H31V31H1V1Z" stroke="currentColor" strokeWidth="2" />
    <path
      d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M13 16H13.0125" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    <path d="M19 16H19.0125" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
  </StrokeSvg>
);

export const DryingLineDryIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M1 1H31M1 1V31H31V1M1 1C1 9.28427 7.71573 16 16 16C24.2843 16 31 9.28427 31 1M1 9L9 1M1 17L17 1"
      stroke="currentColor"
      strokeWidth="2"
    />
  </StrokeSvg>
);

export const DryingLineDryInShadeIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M1 1H31M1 1V31H31V1M1 1C1 9.28427 7.71573 16 16 16C24.2843 16 31 9.28427 31 1M1 9L9 1M1 17L17 1"
      stroke="currentColor"
      strokeWidth="2"
    />
  </StrokeSvg>
);

export const Ironing1Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M17.5 18.5H17.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M12 8H25.3333L28 24H4C4 24 8.33462 13 12.8341 13H26.1541"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const Ironing2Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M14.5 18.5H14.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M19.5 18.5H19.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M12 8H25.3333L28 24H4C4 24 8.33462 13 12.8341 13H26.1541"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const Ironing3Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path d="M12.5 18.5H12.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M17.5 18.5H17.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M22.5 18.5H22.5125" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path
      d="M12 8H25.3333L28 24H4C4 24 8.33462 13 12.8341 13H26.1541"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const IroningDoNotIronIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M12 8H25.3333L28 24H4C4 24 8.33462 13 12.8341 13H26.1541M28 4L4 28M4 4L28 28"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ProfessionalCleaningAIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <circle cx="16" cy="16" r="12" strokeWidth="2" stroke="currentColor" />
    <polyline
      points="11 21 16 10 21 21"
      strokeWidth="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="12.96"
      y1="18"
      x2="19"
      y2="18"
      strokeWidth="2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ProfessionalCleaningAllowedIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="2" />
  </StrokeSvg>
);

export const ProfessionalCleaningDoNotCleanIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M28 4L4 28M4 4L28 28M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const ProfessionalCleaningFIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M13.9999 21V11H19M14 16H18M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </StrokeSvg>
);

export const ProfessionalCleaningPIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <circle strokeWidth="2" cx="16" cy="16" r="12" />
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M14,21V11h3a3.19,3.19,0,0,1,3,3,3.19,3.19,0,0,1-3,3H14"
    />
  </StrokeSvg>
);

export const ProfessionalCleaningWIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <circle cx="16" cy="16" r="12" strokeWidth="2" />
    <polyline
      points="10 11 13 21 16 12 19 21 22 11"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const Washing30Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M28,8,25.17,21.33S24.5,24,22.5,24H9.5c-2,0-2.67-2.67-2.67-2.67L4,8m.67,1.33Q6.94,12,9.2,9.33a2.74,2.74,0,0,1,4.53,0c1.51,1.78,3,1.78,4.54,0s3-1.77,4.53,0,3,1.78,4.53,0"
    />
    <ellipse strokeWidth="2" strokeMiterlimit="10" cx="19.5" cy="16.5" rx="2.5" ry="3.5" />
    <path
      strokeWidth="2"
      d="M10,13.22A4.61,4.61,0,0,1,11,13l.51,0c1.45,0,2.25.76,2.26,1.7,0,1.32-1.46,1.53-2.3,1.81v0c.82.15,2.53.33,2.53,1.78C14,19.48,12.94,20,11.21,20c-.44,0-.21,0-1.21,0"
    />
  </StrokeSvg>
);

export const Washing30CareIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M12.1958 19.4933c-.6933 0-1.28-.1066-1.76-.32-.47999-.2222-.87554-.5155-1.18665-.88l.90665-1.24c.2578.2489.5378.4534.84.6134.3111.16.6489.24 1.0133.24.4178 0 .7512-.0845 1-.2534.2489-.1777.3734-.4266.3734-.7466 0-.1867-.0356-.3556-.1067-.5067-.0622-.1511-.1778-.2756-.3467-.3733-.1688-.1067-.4-.1867-.6933-.24-.2933-.0623-.6711-.0934-1.1333-.0934v-1.3866c.3822 0 .6978-.0267.9466-.08.2578-.0534.4623-.1289.6134-.2267.16-.1067.2711-.2267.3333-.36.0711-.1422.1067-.2978.1067-.4667 0-.2933-.0889-.52-.2667-.68-.1778-.1689-.4355-.2533-.7733-.2533-.3022 0-.5778.0667-.8267.2-.24.1333-.4933.3156-.76.5467l-.98665-1.2c.39111-.3378.79995-.6 1.22665-.7867.4356-.1956.9156-.2933 1.44-.2933.4356 0 .8311.0533 1.1867.16.3644.0977.6711.2489.92.4533.2578.1956.4578.4356.6.72s.2133.6133.2133.9867c0 .4444-.1244.8222-.3733 1.1333-.24.3022-.5867.5511-1.04.7467v.0533c.4889.1422.8889.3867 1.2.7333.32.3378.48.7823.48 1.3334 0 .3911-.0845.7422-.2534 1.0533-.1688.3022-.3955.56-.68.7733-.2844.2045-.6177.3645-1 .48-.3822.1067-.7866.16-1.2133.16ZM19.5201 19.4933c-.4534 0-.8667-.0933-1.24-.28-.3734-.1955-.6934-.48-.96-.8533-.2578-.3733-.4622-.8356-.6134-1.3867-.1422-.5511-.2133-1.1866-.2133-1.9066s.0711-1.3511.2133-1.8934c.1512-.5422.3556-.9955.6134-1.36.2666-.3733.5866-.6489.96-.8266.3733-.1867.7866-.28 1.24-.28.4533 0 .8666.0933 1.24.28.3733.1777.6889.4533.9467.8266.2666.3645.4711.8178.6133 1.36.1511.5423.2266 1.1734.2266 1.8934s-.0755 1.3555-.2266 1.9066c-.1422.5511-.3467 1.0134-.6133 1.3867-.2578.3733-.5734.6578-.9467.8533-.3734.1867-.7867.28-1.24.28Zm0-1.52c.1689 0 .3244-.04.4666-.12.1423-.0889.2667-.2444.3734-.4666.1067-.2223.1867-.52.24-.8934.0622-.3733.0933-.8489.0933-1.4266 0-.5778-.0311-1.0489-.0933-1.4134-.0533-.3733-.1333-.6622-.24-.8666-.1067-.2134-.2311-.36-.3734-.44-.1422-.08-.2977-.12-.4666-.12-.16 0-.3111.04-.4534.12-.1422.08-.2666.2266-.3733.44-.1066.2044-.1911.4933-.2533.8666-.0622.3645-.0934.8356-.0934 1.4134 0 .5777.0312 1.0533.0934 1.4266.0622.3734.1467.6711.2533.8934.1067.2222.2311.3777.3733.4666.1423.08.2934.12.4534.12Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="m28 6-2.8333 13.3333S24.5 22 22.5 22h-13c-2 0-2.66667-2.6667-2.66667-2.6667L4 6m.66667 1.33333c1.51111 1.77778 3.02222 1.77778 4.53333 0 1.5111-1.77777 3.3244-1.42222 4.5333 0 1.5111 1.77778 3.0223 1.77778 4.5334 0 1.5111-1.77777 3.0222-1.77777 4.5333 0 1.5111 1.77778 3.0222 1.77778 4.5333 0M8 26h16"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </StrokeSvg>
);

export const Washing40Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M28,8,25.17,21.33S24.5,24,22.5,24H9.5c-2,0-2.67-2.67-2.67-2.67L4,8m.67,1.33Q6.94,12,9.2,9.33a2.74,2.74,0,0,1,4.53,0c1.51,1.78,3,1.78,4.54,0s3-1.77,4.53,0,3,1.78,4.53,0"
    />
    <ellipse strokeWidth="2" strokeMiterlimit="10" cx="19.5" cy="16.5" rx="2.5" ry="3.5" />
    <path strokeWidth="2" d="M15,18H10V16l2-3h2l0,8" />
  </StrokeSvg>
);

export const Washing40CareIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M12.8757 19.3333v-2.0266H9.20905V15.96l3.09335-5.0933h2.4v4.9466h.9733v1.4934h-.9733v2.0266h-1.8267Zm-1.7867-3.52h1.7867V14.44c0-.2756.0089-.5911.0267-.9467.0178-.3644.0355-.68.0533-.9466h-.0533c-.1067.2311-.2178.4666-.3334.7066-.1155.24-.2355.48-.36.72l-1.12 1.84ZM19.52 19.4933c-.4534 0-.8667-.0933-1.24-.28-.3734-.1955-.6934-.48-.96-.8533-.2578-.3733-.4622-.8356-.6134-1.3867-.1422-.5511-.2133-1.1866-.2133-1.9066s.0711-1.3511.2133-1.8934c.1512-.5422.3556-.9955.6134-1.36.2666-.3733.5866-.6489.96-.8266.3733-.1867.7866-.28 1.24-.28.4533 0 .8667.0933 1.24.28.3733.1777.6889.4533.9466.8266.2667.3645.4712.8178.6134 1.36.1511.5423.2266 1.1734.2266 1.8934s-.0755 1.3555-.2266 1.9066c-.1422.5511-.3467 1.0134-.6134 1.3867-.2577.3733-.5733.6578-.9466.8533-.3733.1867-.7867.28-1.24.28Zm0-1.52c.1689 0 .3244-.04.4666-.12.1423-.0889.2667-.2444.3734-.4666.1066-.2223.1866-.52.24-.8934.0622-.3733.0933-.8489.0933-1.4266 0-.5778-.0311-1.0489-.0933-1.4134-.0534-.3733-.1334-.6622-.24-.8666-.1067-.2134-.2311-.36-.3734-.44-.1422-.08-.2977-.12-.4666-.12-.16 0-.3111.04-.4534.12-.1422.08-.2666.2266-.3733.44-.1067.2044-.1911.4933-.2533.8666-.0622.3645-.0934.8356-.0934 1.4134 0 .5777.0312 1.0533.0934 1.4266.0622.3734.1466.6711.2533.8934.1067.2222.2311.3777.3733.4666.1423.08.2934.12.4534.12Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="m28 6-2.8333 13.3333S24.5 22 22.5 22h-13c-2 0-2.66667-2.6667-2.66667-2.6667L4 6m.66667 1.33333c1.51111 1.77778 3.02222 1.77778 4.53333 0 1.5111-1.77777 3.3244-1.42222 4.5333 0 1.5111 1.77778 3.0223 1.77778 4.5334 0 1.5111-1.77777 3.0222-1.77777 4.5333 0 1.5111 1.77778 3.0222 1.77778 4.5333 0M8 26h16"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </StrokeSvg>
);

export const Washing50Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M28,8,25.17,21.33S24.5,24,22.5,24H9.5c-2,0-2.67-2.67-2.67-2.67L4,8m.67,1.33Q6.94,12,9.2,9.33a2.74,2.74,0,0,1,4.53,0c1.51,1.78,3,1.78,4.54,0s3-1.77,4.53,0,3,1.78,4.53,0"
    />
    <ellipse strokeWidth="2" strokeMiterlimit="10" cx="19.5" cy="16.5" rx="2.5" ry="3.5" />
    <path
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M14.81,13H10.68l-.18,3,1.7.35a2,2,0,0,1,1.93,2.06C14,21,11.65,21.05,9.52,19.48"
    />
  </StrokeSvg>
);

export const Washing60Icon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M28,8,25.17,21.33S24.5,24,22.5,24H9.5c-2,0-2.67-2.67-2.67-2.67L4,8m.67,1.33Q6.94,12,9.2,9.33a2.74,2.74,0,0,1,4.53,0c1.51,1.78,3,1.78,4.54,0s3-1.77,4.53,0,3,1.78,4.53,0"
    />
    <ellipse strokeWidth="2" strokeMiterlimit="10" cx="19.5" cy="16.5" rx="2.5" ry="3.5" />
    <ellipse strokeWidth="2" strokeMiterlimit="10" cx="11.86" cy="18.09" rx="2.14" ry="2.01" />
    <path strokeWidth="2" strokeMiterlimit="10" d="M9.72,18.09C9.72,17.24,9,13,14.33,13" />
  </StrokeSvg>
);

export const Washing60CareIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      d="M12.7024 19.4933c-.4088 0-.8088-.08-1.2-.24-.3822-.16-.7244-.4089-1.0266-.7466-.2934-.3378-.52891-.7689-.70669-1.2934-.17778-.5333-.26667-1.1733-.26667-1.92 0-.7911.09333-1.4755.28-2.0533.19556-.5778.44886-1.0533.75996-1.4267.32-.3733.6845-.6489 1.0934-.8266.4178-.1867.8489-.28 1.2933-.28.56 0 1.0445.1022 1.4533.3066.4089.1956.7467.4311 1.0134.7067l-1.0267 1.1733c-.1511-.16-.3467-.2977-.5867-.4133-.24-.1244-.4844-.1867-.7333-.1867-.2311 0-.4489.0445-.6533.1334-.2045.0889-.3867.24-.5467.4533-.1511.2044-.2755.4756-.3733.8133-.0978.3378-.1556.7511-.1734 1.24.1067-.1422.2312-.2666.3734-.3733.1422-.1156.2889-.2089.44-.28.1511-.08.3022-.1378.4533-.1733.1511-.0445.2933-.0667.4267-.0667.3644 0 .6978.0533 1 .16.3111.1067.5778.2667.8.48.2311.2133.4089.4844.5333.8133.1245.3289.1867.7156.1867 1.16 0 .4445-.0756.84-.2267 1.1867-.1511.3467-.3555.6444-.6133.8933-.2489.2489-.5467.44-.8934.5734-.3377.1244-.6977.1866-1.08.1866Zm-.04-1.4666c.2934 0 .5423-.1067.7467-.32.2133-.2223.32-.5734.32-1.0534 0-.4533-.1067-.7689-.32-.9466-.2044-.1867-.4667-.28-.7867-.28-.2222 0-.4488.0666-.68.2-.2222.1244-.4222.3377-.6.64.0445.3377.1112.6177.2.84.0889.2222.1912.4044.3067.5466.1156.1334.24.2311.3733.2934.1423.0533.2889.08.44.08ZM19.52 19.4933c-.4533 0-.8666-.0933-1.24-.28-.3733-.1955-.6933-.48-.96-.8533-.2577-.3733-.4622-.8356-.6133-1.3867-.1422-.5511-.2133-1.1866-.2133-1.9066s.0711-1.3511.2133-1.8934c.1511-.5422.3556-.9955.6133-1.36.2667-.3733.5867-.6489.96-.8266.3734-.1867.7867-.28 1.24-.28.4534 0 .8667.0933 1.24.28.3734.1777.6889.4533.9467.8266.2667.3645.4711.8178.6133 1.36.1512.5423.2267 1.1734.2267 1.8934s-.0755 1.3555-.2267 1.9066c-.1422.5511-.3466 1.0134-.6133 1.3867-.2578.3733-.5733.6578-.9467.8533-.3733.1867-.7866.28-1.24.28Zm0-1.52c.1689 0 .3245-.04.4667-.12.1422-.0889.2667-.2444.3733-.4666.1067-.2223.1867-.52.24-.8934.0623-.3733.0934-.8489.0934-1.4266 0-.5778-.0311-1.0489-.0934-1.4134-.0533-.3733-.1333-.6622-.24-.8666-.1066-.2134-.2311-.36-.3733-.44-.1422-.08-.2978-.12-.4667-.12-.16 0-.3111.04-.4533.12-.1422.08-.2667.2266-.3733.44-.1067.2044-.1911.4933-.2534.8666-.0622.3645-.0933.8356-.0933 1.4134 0 .5777.0311 1.0533.0933 1.4266.0623.3734.1467.6711.2534.8934.1066.2222.2311.3777.3733.4666.1422.08.2933.12.4533.12Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="m28 6-2.8333 13.3333S24.5 22 22.5 22h-13c-2 0-2.66667-2.6667-2.66667-2.6667L4 6m.66667 1.33333c1.51111 1.77778 3.02222 1.77778 4.53333 0 1.5111-1.77777 3.3244-1.42222 4.5333 0 1.5111 1.77778 3.0223 1.77778 4.5334 0 1.5111-1.77777 3.0222-1.77777 4.5333 0 1.5111 1.77778 3.0222 1.77778 4.5333 0M8 26h16"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </StrokeSvg>
);

export const WashingDoNotWashIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeMiterlimit="10"
      strokeWidth="2"
      strokeLinecap="round"
      d="M28,8s-4,14.09-5,15a3.77,3.77,0,0,1-3,1H12a3.45,3.45,0,0,1-3-1C8,22,4,8,4,8"
    />
    <path
      strokeWidth="2"
      strokeLinecap="round"
      d="M4.47,9.33Q6.74,12,9,9.33a2.75,2.75,0,0,1,4.54,0q2.27,2.67,4.53,0t4.53,0q2.28,2.67,4.54,0"
    />
    <line strokeWidth="2" strokeLinecap="round" x1="3" y1="22" x2="30" y2="10" />
    <line strokeWidth="2" strokeLinecap="round" x1="29" y1="22" x2="2" y2="10" />
  </StrokeSvg>
);

export const WashingOnlyHandWashIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <path
      strokeWidth="2"
      strokeMiterlimit="10"
      d="M28,10s-3,14.09-4,15a3.77,3.77,0,0,1-3,1H11a3.45,3.45,0,0,1-3-1C7,24,4,10,4,10"
    />
    <path strokeWidth="2" strokeLinejoin="round" d="M24,6,20,21H12l1-8s-5,0-5-3l6-2,1-3" />
  </StrokeSvg>
);

export const RepeatIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <path d="m17 1 4 4-4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 13v2a4 4 0 0 1-4 4H3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const SettingsIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <g strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
      <path d="M19 15a2 2 0 0 0 1 2h0a2 2 0 1 1-3 3h0a2 2 0 0 0-2-1 2 2 0 0 0-1 2v0a2 2 0 0 1-4 0v0a2 2 0 0 0-1-2 2 2 0 0 0-2 1h0a2 2 0 1 1-3-3h0a2 2 0 0 0 1-2 2 2 0 0 0-2-1h0a2 2 0 1 1 0-4h0a2 2 0 0 0 2-1 2 2 0 0 0-1-2h0a2 2 0 1 1 3-3h0a2 2 0 0 0 2 1h0a2 2 0 0 0 1-2v0a2 2 0 1 1 4 0v0a2 2 0 0 0 1 2 2 2 0 0 0 2-1h0a2 2 0 1 1 3 3h0a2 2 0 0 0-1 2v0a2 2 0 0 0 2 1h0a2 2 0 0 1 0 4h0a2 2 0 0 0-2 1v0Z" />
    </g>
  </StrokeSvg>
);

export const LogoutIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <g>
      <g id="Sign_Out">
        <path
          d="M15,30H2V2h13c0.552,0,1-0.448,1-1s-0.448-1-1-1H1C0.448,0,0,0.448,0,1v30c0,0.552,0.448,1,1,1h14   c0.552,0,1-0.448,1-1S15.552,30,15,30z"
          fill="#121313"
        />
        <path
          d="M31.71,15.302l-6.9-6.999c-0.391-0.395-1.024-0.394-1.414,0c-0.391,0.394-0.391,1.034,0,1.428l5.2,5.275   H8.003c-0.552,0-1,0.452-1,1.01c0,0.558,0.448,1.01,1,1.01h20.593l-5.2,5.275c-0.391,0.395-0.391,1.034,0,1.428   c0.391,0.395,1.024,0.395,1.414,0l6.899-6.999C32.095,16.341,32.099,15.69,31.71,15.302z"
          fill="#121313"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </g>
  </StrokeSvg>
);

export const ServicePointIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 64 64" className={className}>
    <g data-name="16 hand delivery box">
      <path d="m60.27 42.62-.43-1.19a3.851 3.851 0 0 0-4.2-2.42c-.05.01-.09.01-.14.02V13.5c0-.01-.01-.02-.01-.04a.8.8 0 0 0-.06-.3.637.637 0 0 0-.02-.07c-.01-.01-.01-.03-.02-.04l-3-6a.988.988 0 0 0-.89-.55h-27a1 1 0 0 0-.83.45l-4 6a.388.388 0 0 0-.06.11c-.01.03-.03.05-.04.08a1.372 1.372 0 0 0-.07.34v19.44c-.15.02-.3.04-.45.07l-4.08.92V30.5a2.006 2.006 0 0 0-2-2H5.5a2.006 2.006 0 0 0-2 2v25a2.006 2.006 0 0 0 2 2h7.47a2.006 2.006 0 0 0 2-2v-2.61l16.53 2.99a12.715 12.715 0 0 0 7-.69l19.52-7.73a3.8 3.8 0 0 0 2.25-4.84ZM12.97 55.5H5.5v-25h7.47Zm29.53-47h8.38l2 4H42.5Zm-8 0h6v4h-6Zm0 6h6v12l-2.4-1.8a1 1 0 0 0-1.2 0l-2.4 1.8Zm-9.46-6h7.46v4H22.37Zm-3.54 6h11v14a.977.977 0 0 0 .55.89 1 1 0 0 0 1.05-.09l3.4-2.55 3.4 2.55a1.029 1.029 0 0 0 .6.2.908.908 0 0 0 .45-.11.977.977 0 0 0 .55-.89v-14h11v24.78c-.5.07-1.01.15-1.5.24-1.01.16-2.06.34-3.08.44a53.558 53.558 0 0 1-7.03.33 53.365 53.365 0 0 1-5.91-.52 3.661 3.661 0 0 0-.33-2.03 4 4 0 0 0-2.54-2.08l-9.48-2.57a9.536 9.536 0 0 0-2.13-.32Zm35.78 31.1-19.51 7.73a10.729 10.729 0 0 1-5.91.58l-16.89-3.05v-14.9l4.52-1.02a7.517 7.517 0 0 1 3.62.08l9.47 2.57a1.992 1.992 0 0 1 1.27 1.02 1.725 1.725 0 0 1 .03 1.44 2.036 2.036 0 0 1-2.02 1.17l-8.22-1.7a1 1 0 0 0-.41 1.96l8.28 1.71a.355.355 0 0 0 .1.02c.14.01.27.02.4.02a4.068 4.068 0 0 0 3.2-1.55 56.551 56.551 0 0 0 6.62.61 55.905 55.905 0 0 0 7.3-.34c1.08-.11 2.16-.29 3.2-.46 1.14-.19 2.32-.39 3.48-.49a1.969 1.969 0 0 1 2.15 1.12l.43 1.18a1.814 1.814 0 0 1-1.11 2.3Z" />
      <path d="M49.5 31.5h-6a2.006 2.006 0 0 0-2 2v2a2.006 2.006 0 0 0 2 2h6a2.006 2.006 0 0 0 2-2v-2a2.006 2.006 0 0 0-2-2Zm0 4h-6v-2h6Z" />
    </g>
  </StrokeSvg>
);

export const WrenchIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 24 24" className={className}>
    <g
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeWidth="2"
      fill="none"
      stroke="currentColor"
      className="nc-icon-wrapper">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </g>
  </StrokeSvg>
);

export const PersonIcon = ({
  className,
  ...props
}: IStyledIcon & React.ComponentProps<typeof FillSvg>) => (
  <FillSvg viewBox="0 0 24 24" className={className} {...props}>
    <path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01m0-11C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z" />
  </FillSvg>
);

export const GridFilterActiveSmall = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <rect x="5" y="1" width="9" height="13" rx="1" stroke="black" strokeWidth="2" />
    <rect x="5" y="18" width="9" height="13" rx="1" stroke="black" strokeWidth="2" />
    <rect x="18" y="1" width="9" height="13" rx="1" stroke="black" strokeWidth="2" />
    <rect x="18" y="18" width="9" height="13" rx="1" stroke="black" strokeWidth="2" />
  </StrokeSvg>
);
export const GridFilterPassiveSmall = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <rect x="4" width="11" height="15" rx="2" fill="#E6E6E6" />
    <rect x="4" y="17" width="11" height="15" rx="2" fill="#E6E6E6" />
    <rect x="17" width="11" height="15" rx="2" fill="#E6E6E6" />
    <rect x="17" y="17" width="11" height="15" rx="2" fill="#E6E6E6" />
  </FillSvg>
);

export const GridFilterHoverSmall = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <rect x="5" y="1" width="9" height="13" rx="1" stroke="#808080" strokeWidth="2" />
    <rect x="5" y="18" width="9" height="13" rx="1" stroke="#808080" strokeWidth="2" />
    <rect x="18" y="1" width="9" height="13" rx="1" stroke="#808080" strokeWidth="2" />
    <rect x="18" y="18" width="9" height="13" rx="1" stroke="#808080" strokeWidth="2" />
  </StrokeSvg>
);

export const GridFilterActiveLarge = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <rect x="5" y="1" width="22" height="30" rx="3" stroke="black" strokeWidth="2" />;
  </StrokeSvg>
);
export const GridFilterPassiveLarge = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 32 32" className={className}>
    <rect x="4" width="24" height="32" rx="4" fill="#E6E6E6" />
  </FillSvg>
);

export const GridFilterHoverLarge = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 32 32" className={className}>
    <rect x="5" y="1" width="22" height="30" rx="3" fill="white" stroke="#808080" strokeWidth="2" />
  </StrokeSvg>
);

export const EnergyBadgeA = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#00A652" />
    <path d="M12 24L12 0L1.04907e-06 12L12 24Z" fill="#00A652" />
    <path
      d="M22.5166 11.648L21.9646 13.568H25.9726L25.4206 11.648C25.1646 10.816 24.9166 9.95996 24.6766 9.07996C24.4526 8.19996 24.2286 7.32796 24.0046 6.46396H23.9086C23.7006 7.34396 23.4766 8.22396 23.2366 9.10396C23.0126 9.96796 22.7726 10.816 22.5166 11.648ZM17.2606 20L22.3726 4.30396H25.6366L30.7486 20H27.8206L26.5966 15.752H21.3166L20.0926 20H17.2606Z"
      fill="white"
    />
  </FillSvg>
);

export const EnergyBadgeB = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#51B747" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#51B747" />
    <path
      d="M18.8318 20V4.30396H23.8478C24.9358 4.30396 25.8958 4.42395 26.7278 4.66395C27.5758 4.90396 28.2398 5.31196 28.7198 5.88796C29.2158 6.44796 29.4638 7.20796 29.4638 8.16796C29.4638 8.90396 29.2718 9.59996 28.8878 10.256C28.5038 10.896 27.9678 11.336 27.2798 11.576V11.672C28.1438 11.864 28.8558 12.272 29.4158 12.896C29.9918 13.504 30.2798 14.336 30.2798 15.392C30.2798 16.432 30.0158 17.296 29.4878 17.984C28.9758 18.672 28.2638 19.184 27.3518 19.52C26.4398 19.84 25.4078 20 24.2558 20H18.8318ZM21.6158 10.784H23.6078C24.6958 10.784 25.4878 10.584 25.9838 10.184C26.4798 9.78396 26.7278 9.24796 26.7278 8.57596C26.7278 7.80796 26.4718 7.26396 25.9598 6.94396C25.4478 6.62396 24.6798 6.46396 23.6558 6.46396H21.6158V10.784ZM21.6158 17.84H23.9678C25.1198 17.84 26.0078 17.632 26.6318 17.216C27.2558 16.784 27.5678 16.128 27.5678 15.248C27.5678 14.416 27.2638 13.816 26.6558 13.448C26.0478 13.064 25.1518 12.872 23.9678 12.872H21.6158V17.84Z"
      fill="white"
    />
  </FillSvg>
);
export const EnergyBadgeC = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#BDD630" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#BDD630" />
    <path
      d="M25.3419 20.288C24.0299 20.288 22.8379 19.976 21.7659 19.352C20.6939 18.728 19.8379 17.816 19.1979 16.616C18.5739 15.4 18.2619 13.928 18.2619 12.2C18.2619 10.488 18.5819 9.02399 19.2219 7.80799C19.8779 6.57599 20.7499 5.63999 21.8379 4.99999C22.9259 4.34399 24.1259 4.01599 25.4379 4.01599C26.4299 4.01599 27.3099 4.21599 28.0779 4.61599C28.8459 5.01599 29.4779 5.47999 29.9739 6.00799L28.4859 7.80799C28.0859 7.39199 27.6379 7.06399 27.1419 6.82399C26.6619 6.56799 26.1179 6.43999 25.5099 6.43999C24.6619 6.43999 23.9019 6.67199 23.2299 7.13599C22.5739 7.58399 22.0539 8.23199 21.6699 9.07999C21.3019 9.92799 21.1179 10.944 21.1179 12.128C21.1179 13.92 21.5099 15.328 22.2939 16.352C23.0779 17.36 24.1259 17.864 25.4379 17.864C26.1419 17.864 26.7659 17.72 27.3099 17.432C27.8539 17.128 28.3499 16.736 28.7979 16.256L30.2859 18.008C29.6459 18.744 28.9099 19.312 28.0779 19.712C27.2619 20.096 26.3499 20.288 25.3419 20.288Z"
      fill="white"
    />
  </FillSvg>
);
export const EnergyBadgeD = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#FEF200" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#FEF200" />
    <path
      d="M18.492 20V4.30396H22.692C25.092 4.30396 26.964 4.95196 28.308 6.24796C29.652 7.54396 30.324 9.48796 30.324 12.08C30.324 14.688 29.66 16.664 28.332 18.008C27.004 19.336 25.172 20 22.836 20H18.492ZM21.276 17.744H22.5C24.084 17.744 25.308 17.288 26.172 16.376C27.036 15.448 27.468 14.016 27.468 12.08C27.468 10.16 27.036 8.75996 26.172 7.87996C25.308 6.99996 24.084 6.55996 22.5 6.55996H21.276V17.744Z"
      fill="white"
    />
  </FillSvg>
);
export const EnergyBadgeE = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#FDB813" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#FDB813" />
    <path
      d="M19.535 20V4.30396H28.991V6.65595H22.319V10.664H27.959V13.016H22.319V17.648H29.231V20H19.535Z"
      fill="white"
    />
  </FillSvg>
);
export const EnergyBadgeF = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#F37020" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#F37020" />
    <path
      d="M19.8748 20V4.30396H29.3548V6.65595H22.6588V11.096H28.3708V13.448H22.6588V20H19.8748Z"
      fill="white"
    />
  </FillSvg>
);
export const EnergyBadgeG = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 36 24" className={className}>
    <rect x="12" width="24" height="24" fill="#ED1B24" />
    <path d="M12 24L12 0L0 12L12 24Z" fill="#ED1B24" />
    <path
      d="M25.0328 20.288C23.6248 20.288 22.3608 19.976 21.2408 19.352C20.1208 18.728 19.2408 17.816 18.6008 16.616C17.9608 15.4 17.6408 13.928 17.6408 12.2C17.6408 10.488 17.9688 9.02399 18.6248 7.80799C19.2808 6.57599 20.1688 5.63999 21.2888 4.99999C22.4088 4.34399 23.6648 4.01599 25.0568 4.01599C26.1768 4.01599 27.1208 4.22399 27.8888 4.63999C28.6728 5.03999 29.3128 5.49599 29.8088 6.00799L28.3208 7.80799C27.9208 7.42399 27.4728 7.10399 26.9768 6.84799C26.4968 6.57599 25.8888 6.43999 25.1528 6.43999C23.7608 6.43999 22.6328 6.95199 21.7688 7.97599C20.9208 8.98399 20.4968 10.368 20.4968 12.128C20.4968 13.92 20.9048 15.328 21.7208 16.352C22.5368 17.36 23.7288 17.864 25.2968 17.864C25.7448 17.864 26.1688 17.808 26.5688 17.696C26.9688 17.568 27.2968 17.392 27.5528 17.168V13.784H24.5768V11.504H30.0488V18.416C29.5208 18.944 28.8168 19.392 27.9368 19.76C27.0728 20.112 26.1048 20.288 25.0328 20.288Z"
      fill="white"
    />
  </FillSvg>
);
export const NewTabIcon = ({
  className,
  ...props
}: IStyledIcon & React.ComponentProps<typeof FillSvg>): ReactElement => (
  <FillSvg viewBox="0 0 512 512" className={className} {...props}>
    <path
      d="M384,224V408a40,40,0,0,1-40,40H104a40,40,0,0,1-40-40V168a40,40,0,0,1,40-40H271.48"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <polyline
      points="336 64 448 64 448 176"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
    />
    <line
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="32"
      x1="224"
      x2="440"
      y1="288"
      y2="72"
    />
  </FillSvg>
);

export const MinimizeIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 16 16" className={className}>
    <path d="M3 8H13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </StrokeSvg>
);

export const ChatIcon = ({ className }: IStyledIcon): ReactElement => (
  <StrokeSvg viewBox="0 0 16 16" className={className}>
    <path
      d="M4.65493 10.6728C4.58535 10.6421 4.5164 10.6097 4.44814 10.5758L1 11.7059L2.14938 8.31569C1.7894 7.61498 1.60286 6.84058 1.60494 6.05556C1.60531 5.11687 1.87148 4.19682 2.37364 3.39846C2.87581 2.6001 3.59413 1.95496 4.44814 1.53531C5.16083 1.18138 5.94847 0.99797 6.7469 1.00002H7.04937C8.31027 1.06841 9.50121 1.59167 10.3942 2.46961C10.7384 2.80806 11.029 3.19005 11.2602 3.60273M7.22223 9.96406C7.22075 10.5248 7.35399 11.0779 7.61112 11.5784C7.916 12.1782 8.38469 12.6827 8.96469 13.0353C9.5447 13.388 10.2131 13.5749 10.8951 13.5752C11.4654 13.5766 12.028 13.4456 12.537 13.1928L15 14L14.179 11.5784C14.4361 11.0779 14.5694 10.5248 14.5679 9.96406C14.5676 9.29356 14.3775 8.63638 14.0188 8.06613C13.6601 7.49587 13.1471 7.03506 12.537 6.73531C12.028 6.4825 11.4654 6.35149 10.8951 6.35295H10.679C9.77838 6.40181 8.92771 6.77556 8.28989 7.40266C7.65207 8.02976 7.27192 8.86614 7.22223 9.75164V9.96406Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </StrokeSvg>
);

export const GroupIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 24 24" className={className}>
    <g id="Group">
      <path
        id="Vector"
        d="M19.1819 12.8181V10.0908C19.1819 9.84968 19.0861 9.61845 18.9156 9.44796C18.7451 9.27747 18.5139 9.18169 18.2728 9.18169H11.0001C10.759 9.18169 10.5277 9.27747 10.3573 9.44796C10.1868 9.61845 10.091 9.84968 10.091 10.0908V12.8181"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        id="Vector_2"
        d="M17.3636 13.7274V15.5456H11.909V13.7274C11.909 13.4863 11.8133 13.2551 11.6428 13.0846C11.4723 12.9141 11.2411 12.8183 11 12.8183H9.18177C8.94066 12.8183 8.70943 12.9141 8.53894 13.0846C8.36846 13.2551 8.27268 13.4863 8.27268 13.7274V19.1819H21V13.7274C21 13.4863 20.9042 13.2551 20.7337 13.0846C20.5632 12.9141 20.332 12.8183 20.0909 12.8183H18.2727C18.0316 12.8183 17.8003 12.9141 17.6299 13.0846C17.4594 13.2551 17.3636 13.4863 17.3636 13.7274Z"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        id="Vector_3"
        d="M10.091 19.1817V20.9999"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        id="Vector_4"
        d="M19.1817 19.1817V20.9999"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        id="Vector_5"
        d="M4.63634 21.0001V10.091"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        id="Vector_6"
        d="M6.45454 1H2.81818L1 4.63636V6.45455H8.27273V4.63636L6.45454 1Z"
        stroke="currentColor"
        strokeWidth="1.66"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </g>
  </FillSvg>
);

export const PauseIcon = ({ className }: IStyledIcon): ReactElement => (
  <FillSvg viewBox="0 0 56 56" className={className} xmlns="http://www.w3.org/2000/svg">
    <path d="M14 9.63333C14 9.46764 14.1343 9.33333 14.3 9.33333H23.0333C23.199 9.33333 23.3333 9.46764 23.3333 9.63333V46.3667C23.3333 46.5323 23.199 46.6667 23.0333 46.6667H14.3C14.1343 46.6667 14 46.5323 14 46.3667V9.63333Z" />
    <path d="M32.6667 9.63333C32.6667 9.46764 32.8011 9.33333 32.9667 9.33333H41.7001C41.8658 9.33333 42.0001 9.46764 42.0001 9.63333V46.3667C42.0001 46.5323 41.8658 46.6667 41.7001 46.6667H32.9667C32.8011 46.6667 32.6667 46.5323 32.6667 46.3667V9.63333Z" />
  </FillSvg>
);

type IconComponent =
  | React.FC<IStyledIcon>
  | React.ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>>;

export const IconMap: Record<string, IconComponent> = {
  app: AppIcon,
  arrowdown: ArrowDownIcon,
  arrowleft: ArrowLeftIcon,
  arrowright: ArrowRightIcon,
  arrowup: ArrowUpIcon,
  ban: BanIcon,
  bars: BarsIcon,
  barsalt: BarsAltIcon,
  bleachingallowed: BleachingAllowedIcon,
  bleachingdonotbleach: BleachingDoNotBleachIcon,
  bleachingonlynonchlorine: BleachingOnlyNonChlorineIcon,
  bookopen: BookOpenIcon,
  box: BoxIcon,
  boxinsidehouse: BoxInsideHouseIcon,
  boxoutsidehouse: BoxOutsideHouseIcon,
  brandedcheckcirclesolid: BrandedCheckCircleSolidIcon,
  calendar: CalendarIcon,
  cart: CartIcon,
  cartarrowdown: CartArrowDownIcon,
  cartslash: CartSlashIcon,
  chairinsidehouse: ChairInsideHouseIcon,
  chat: ChatIcon,
  check: CheckIcon,
  checkcircle: CheckCircleIcon,
  checkcirclesolid: CheckCircleSolidIcon,
  chevrondown: ChevronDownIcon,
  chevronleft: ChevronLeftIcon,
  chevronright: ChevronRightIcon,
  chevronup: ChevronUpIcon,
  clock: ClockIcon,
  close: CloseIcon,
  download: DownloadIcon,
  dryingdonottumbledry: DryingDoNotTumbleDryIcon,
  dryingdripdry: DryingDripDryIcon,
  dryingdripdryinshade: DryingDripDryInShadeIcon,
  dryingdryflat: DryingDryFlatIcon,
  dryingdryflatinshade: DryingDryFlatInShadeIcon,
  dryinglinedry: DryingLineDryIcon,
  dryinglinedryinshade: DryingLineDryInShadeIcon,
  dryingtumbledryingallowed: DryingTumbleDryingAllowedIcon,
  dryingtumbledryinglow: DryingTumbleDryingLowIcon,
  dryingtumbledryingnormal: DryingTumbleDryingNormalIcon,
  edit: EditIcon,
  energybadgea: EnergyBadgeA,
  energybadgeb: EnergyBadgeB,
  energybadgec: EnergyBadgeC,
  energybadged: EnergyBadgeD,
  energybadgee: EnergyBadgeE,
  energybadgef: EnergyBadgeF,
  energybadgeg: EnergyBadgeG,
  envelope: EnvelopeIcon,
  envelopeopen: EnvelopeOpenIcon,
  envelopesolid: EnvelopeSolidIcon,
  errortriangle: ErrorTriangleIcon,
  exclamationcircle: ExclamationCircleIcon,
  exclamationtriangle: ExclamationTriangleIcon,
  facebook: FacebookIcon,
  filter: FilterIcon,
  filteralt: FilterAltIcon,
  fliptoback: FlipToBackIcon,
  fliptofront: FlipToFrontIcon,
  forbidden: ForbiddenIcon,
  formchecklist: FormChecklistIcon,
  formchecklistalt: FormChecklistAltIcon,
  formpage: FormPageIcon,
  fullscreen: FullscreenIcon,
  googleplussolid: GooglePlusSolidIcon,
  gridfilteractivelarge: GridFilterActiveLarge,
  gridfilteractivesmall: GridFilterActiveSmall,
  gridfilterhoverlarge: GridFilterHoverLarge,
  gridfilterhoversmall: GridFilterHoverSmall,
  gridfilterpassivelarge: GridFilterPassiveLarge,
  gridfilterpassivesmall: GridFilterPassiveSmall,
  group: GroupIcon,
  headset: HeadsetIcon,
  heart: HeartIcon,
  heartsolid: HeartSolidIcon,
  helpcircle: HelpCircleIcon,
  home: HomeIcon,
  homeslash: HomeSlashIcon,
  info: InfoIcon,
  infosolid: InfoSolidIcon,
  instagram: InstagramIcon,
  ironing1: Ironing1Icon,
  ironing2: Ironing2Icon,
  ironing3: Ironing3Icon,
  ironingdonotiron: IroningDoNotIronIcon,
  laptop: LaptopIcon,
  listul: ListUlIcon,
  locationarrow: LocationArrowIcon,
  login: LogInIcon,
  logout: LogoutIcon,
  mail: MailIcon,
  mapmarker: MapMarkerIcon,
  mapmarkersolid: MapMarkerSolidIcon,
  menu: MenuIcon,
  minimize: MinimizeIcon,
  minus: MinusIcon,
  minuscircle: MinusCircleIcon,
  miologo: MioLogoIcon,
  newtab: NewTabIcon,
  package: PackageIcon,
  page: PageIcon,
  palette: PaletteIcon,
  pause: PauseIcon,
  pen: PenIcon,
  person: PersonIcon,
  phone: PhoneIcon,
  pinterest: PinterestIcon,
  pinterestsolid: PinterestSolidIcon,
  play: PlayIcon,
  plus: PlusIcon,
  print: PrintIcon,
  professionalcleaninga: ProfessionalCleaningAIcon,
  professionalcleaningallowed: ProfessionalCleaningAllowedIcon,
  professionalcleaningdonotclean: ProfessionalCleaningDoNotCleanIcon,
  professionalcleaningf: ProfessionalCleaningFIcon,
  professionalcleaningp: ProfessionalCleaningPIcon,
  professionalcleaningw: ProfessionalCleaningWIcon,
  quoteleft: QuoteLeftIcon,
  quoteright: QuoteRightIcon,
  redoslash: RedoSlashIcon,
  repeat: RepeatIcon,
  save: SaveIcon,
  search: SearchIcon,
  searchslash: SearchSlashIcon,
  servicepoint: ServicePointIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  sliders: SlidersIcon,
  sort: SortIcon,
  sortalt: SortAltIcon,
  sortdown: SortDownIcon,
  sortup: SortUpIcon,
  stockcheck: StockCheckIcon,
  stockcross: StockCrossIcon,
  stockdelivery: StockDeliveryIcon,
  stockfastdelivery: StockFastDeliveryIcon,
  store: StoreIcon,
  target: TargetIcon,
  thumbdown: ThumbDownIcon,
  thumbup: ThumbUpIcon,
  times: TimesIcon,
  timescircle: TimesCircleIcon,
  tools: ToolsIcon,
  trashcan: TrashcanIcon,
  truck: TruckIcon,
  twittersolid: TwitterSolidIcon,
  user: UserIcon,
  usersolid: UserSolidIcon,
  wallet: WalletIcon,
  washing30: Washing30Icon,
  washing30care: Washing30CareIcon,
  washing40: Washing40Icon,
  washing40care: Washing40CareIcon,
  washing50: Washing50Icon,
  washing60: Washing60Icon,
  washing60care: Washing60CareIcon,
  washingdonotwash: WashingDoNotWashIcon,
  washingonlyhandwash: WashingOnlyHandWashIcon,
  wrench: WrenchIcon,
  zoomin: ZoomInIcon,
  zoomout: ZoomOutIcon,
  shield: ShieldIcon,
  codesandbox: CodesandboxIcon,
  cameraoff: CameraOffIcon,
  book: BookIcon,
  cloudrain: CloudRainIcon,
  cornerrightup: CornerRightUpIcon,
  barchart: BarChartIcon,
  clipboard: ClipboardIcon,
  arrowrightcircle: ArrowRightCircleIcon,
  archive: ArchiveIcon,
  alignjustify: AlignJustifyIcon,
  command: CommandIcon,
  listfilter: ListFilterIcon,
  badgepercent: BadgePercentIcon,
  shieldcheck: ShieldCheckIcon,
  copy: CopyIcon,
  externallink: ExternalLinkIcon,
  accessibility: AccessibilityIcon,
  receipttext: ReceiptTextIcon,
  baby: BabyIcon,
  leaf: LeafIcon,
  newspaper: NewspaperIcon,
  expand: ExpandIcon,
  scissorslinedashed: ScissorsLineDashedIcon,
  ruler: RulerIcon,
  pencil: PencilIcon,
  arrowdownup: ArrowDownUpIcon,
  beddouble: BedDoubleIcon,
  slidershorizontal: SlidersHorizontalIcon,
  griphorizontal: GripHorizontalIcon,
  paintbrush: PaintbrushIcon,
  shuffle: ShuffleIcon,
  listcheck: ListCheckIcon,
  swatchbook: SwatchBookIcon,
  batterycharging: BatteryChargingIcon,
  codepen: CodepenIcon,
  cornerupleft: CornerUpLeftIcon,
  camera: CameraIcon,
  alertcircle: AlertCircleIcon,
  compass: CompassIcon,
  alignleft: AlignLeftIcon,
  chevronsup: ChevronsUpIcon,
  cloudoff: CloudOffIcon,
  aperture: ApertureIcon,
  coffee: CoffeeIcon,
  briefcase: BriefcaseIcon,
  anchor: AnchorIcon,
  alertoctagon: AlertOctagonIcon,
  award: AwardIcon,
  chevronsleft: ChevronsLeftIcon,
  cpu: CpuIcon,
  cornerleftup: CornerLeftUpIcon,
  circle: CircleIcon,
  belloff: BellOffIcon,
  airplay: AirplayIcon,
  clouddrizzle: CloudDrizzleIcon,
  arrowupleft: ArrowUpLeftIcon,
  chevronsdown: ChevronsDownIcon,
  battery: BatteryIcon,
  cornerupright: CornerUpRightIcon,
  arrowleftcircle: ArrowLeftCircleIcon,
  cloudsnow: CloudSnowIcon,
  bookmark: BookmarkIcon,
  folderminus: FolderMinusIcon,
  gitmerge: GitMergeIcon,
  dollarsign: DollarSignIcon,
  figma: FigmaIcon,
  gitcommit: GitCommitIcon,
  edit2: Edit2Icon,
  disc: DiscIcon,
  flag: FlagIcon,
  globe: GlobeIcon,
  feather: FeatherIcon,
  droplet: DropletIcon,
  fastforward: FastForwardIcon,
  gitlab: GitlabIcon,
  framer: FramerIcon,
  hexagon: HexagonIcon,
  delete: DeleteIcon,
  aligncenter: AlignCenterIcon,
  columns: ColumnsIcon,
  creditcard: CreditCardIcon,
  cornerrightdown: CornerRightDownIcon,
  barchart2: BarChart2Icon,
  bell: BellIcon,
  arrowupcircle: ArrowUpCircleIcon,
  minimize2: Minimize2Icon,
  layers: LayersIcon,
  cornerdownright: CornerDownRightIcon,
  piechart: PieChartIcon,
  mic: MicIcon,
  percent: PercentIcon,
  navigation2: Navigation2Icon,
  map: MapIcon,
  linkedin: LinkedinIcon,
  github: GithubIcon,
  film: FilmIcon,
  folder: FolderIcon,
  inbox: InboxIcon,
  fileminus: FileMinusIcon,
  downloadcloud: DownloadCloudIcon,
  eye: EyeIcon,
  gitpullrequest: GitPullRequestIcon,
  folderplus: FolderPlusIcon,
  eyeoff: EyeOffIcon,
  grid: GridIcon,
  image: ImageIcon,
  rss: RssIcon,
  link2: Link2Icon,
  refreshcw: RefreshCwIcon,
  phoneincoming: PhoneIncomingIcon,
  move: MoveIcon,
  meh: MehIcon,
  pluscircle: PlusCircleIcon,
  lifebuoy: LifeBuoyIcon,
  phoneforwarded: PhoneForwardedIcon,
  mousepointer: MousePointerIcon,
  octagon: OctagonIcon,
  rotatecw: RotateCwIcon,
  refreshccw: RefreshCcwIcon,
  maximize: MaximizeIcon,
  phonecall: PhoneCallIcon,
  rotateccw: RotateCcwIcon,
  maximize2: Maximize2Icon,
  pocket: PocketIcon,
  list: ListIcon,
  playcircle: PlayCircleIcon,
  layout: LayoutIcon,
  navigation: NavigationIcon,
  morevertical: MoreVerticalIcon,
  triangle: TriangleIcon,
  toggleleft: ToggleLeftIcon,
  skipback: SkipBackIcon,
  sunset: SunsetIcon,
  smartphone: SmartphoneIcon,
  share2: Share2Icon,
  trash: TrashIcon,
  sunrise: SunriseIcon,
  thumbsup: ThumbsUpIcon,
  sidebar: SidebarIcon,
  rewind: RewindIcon,
  sun: SunIcon,
  thumbsdown: ThumbsDownIcon,
  slash: SlashIcon,
  trash2: Trash2Icon,
  server: ServerIcon,
  plussquare: PlusSquareIcon,
  micoff: MicOffIcon,
  link: LinkIcon,
  send: SendIcon,
  mappin: MapPinIcon,
  music: MusicIcon,
  pentool: PenToolIcon,
  minussquare: MinusSquareIcon,
  phonemissed: PhoneMissedIcon,
  umbrella: UmbrellaIcon,
  userx: UserXIcon,
  wifi: WifiIcon,
  volume2: Volume2Icon,
  userplus: UserPlusIcon,
  type: TypeIcon,
  zapoff: ZapOffIcon,
  wifioff: WifiOffIcon,
  volume1: Volume1Icon,
  twitter: TwitterIcon,
  userminus: UserMinusIcon,
  youtube: YoutubeIcon,
  users: UsersIcon,
  watch: WatchIcon,
  twitch: TwitchIcon,
  usercheck: UserCheckIcon,
  slack: SlackIcon,
  tv: TvIcon,
  stopcircle: StopCircleIcon,
  tag: TagIcon,
  shieldoff: ShieldOffIcon,
  toggleright: ToggleRightIcon,
  tablet: TabletIcon,
  star: StarIcon,
  skipforward: SkipForwardIcon,
  crop: CropIcon,
  cornerdownleft: CornerDownLeftIcon,
  monitor: MonitorIcon,
  underline: UnderlineIcon,
  checksquare: CheckSquareIcon,
  trello: TrelloIcon,
  loader: LoaderIcon,
  chevronsright: ChevronsRightIcon,
  smile: SmileIcon,
  cast: CastIcon,
  harddrive: HardDriveIcon,
  shoppingbag: ShoppingBagIcon,
  bluetooth: BluetoothIcon,
  frown: FrownIcon,
  arrowupright: ArrowUpRightIcon,
  zap: ZapIcon,
  x: XIcon,
  volume: VolumeIcon,
  upload: UploadIcon,
  xsquare: XSquareIcon,
  volumex: VolumeXIcon,
  cornerleftdown: CornerLeftDownIcon,
  crosshair: CrosshairIcon,
  code: CodeIcon,
  chrome: ChromeIcon,
  cloud: CloudIcon,
  arrowdownleft: ArrowDownLeftIcon,
  arrowdownright: ArrowDownRightIcon,
  bold: BoldIcon,
  alerttriangle: AlertTriangleIcon,
  alignright: AlignRightIcon,
  activity: ActivityIcon,
  power: PowerIcon,
  cloudlightning: CloudLightningIcon,
  fileplus: FilePlusIcon,
  arrowdowncircle: ArrowDownCircleIcon,
  phoneoff: PhoneOffIcon,
  wind: WindIcon,
  edit3: Edit3Icon,
  videooff: VideoOffIcon,
  shoppingcart: ShoppingCartIcon,
  scansearch: ScanSearchIcon,
  scissors: ScissorsIcon,
  radio: RadioIcon,
  printer: PrinterIcon,
  pausecircle: PauseCircleIcon,
  phoneoutgoing: PhoneOutgoingIcon,
  morehorizontal: MoreHorizontalIcon,
  paperclip: PaperclipIcon,
  messagesquare: MessageSquareIcon,
  moon: MoonIcon,
  messagecircle: MessageCircleIcon,
  headphones: HeadphonesIcon,
  italic: ItalicIcon,
  gitbranch: GitBranchIcon,
  hash: HashIcon,
  file: FileIcon,
  gift: GiftIcon,
  filetext: FileTextIcon,
  database: DatabaseIcon,
  xoctagon: XOctagonIcon,
  xcircle: XCircleIcon,
  voicemail: VoicemailIcon,
  video: VideoIcon,
  uploadcloud: UploadCloudIcon,
  unlock: UnlockIcon,
  trendingup: TrendingUpIcon,
  trendingdown: TrendingDownIcon,
  thermometer: ThermometerIcon,
  terminal: TerminalIcon,
  square: SquareIcon,
  speaker: SpeakerIcon,
};

export interface IDynamicIcon extends IStyledIcon {
  name: string;
  size?: IconSize;
}

const sizeMap: Record<IconSize, number> = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48,
  xxxl: 56,
};

export const DynamicIcon = ({ name = '', className, strokeWidth, size }: IDynamicIcon) => {
  const IconComponent = IconMap[name.toLocaleLowerCase()];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  // Check if the icon is a Lucide icon and pass the props accordingly
  if (typeof IconComponent === 'object') {
    const LucideIcon = IconComponent as React.ForwardRefExoticComponent<
      Omit<LucideProps, 'ref'> & React.RefAttributes<SVGSVGElement>
    >;
    const lucideSize = sizeMap[size || 'sm'];

    return <LucideIcon size={lucideSize} strokeWidth={strokeWidth} />;
  }

  return <IconComponent name={name} className={className} strokeWidth={strokeWidth} />;
};
